import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date only string in the ISO 8601 format */
  Date: { input: any; output: any; }
  /** A date only string in the format YYYY-MM-DD */
  DateOnlyString: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** A validated email in lower case */
  Email: { input: any; output: any; }
};

export type AcceptReservationAgreementInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  id: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  singleLineAddress?: Maybe<Scalars['String']['output']>;
};

export enum AgeRange {
  From0To10 = 'From0To10',
  From10To50 = 'From10To50',
  From50To100 = 'From50To100',
  New = 'New',
  Over100 = 'Over100'
}

export type AiDocReview = {
  __typename?: 'AiDocReview';
  file: File;
  id: Scalars['Int']['output'];
  status: AiDocReviewStatus;
  type: DocType;
};

export enum AiDocReviewStatus {
  Complete = 'Complete',
  FileUploaded = 'FileUploaded',
  PartiallyComplete = 'PartiallyComplete',
  UploadingFile = 'UploadingFile'
}

export enum AuthStatus {
  AccountHolder = 'AccountHolder',
  AnonymousVisitor = 'AnonymousVisitor',
  IdentifiedVisitor = 'IdentifiedVisitor',
  None = 'None'
}

export enum BusinessType {
  Conveyancer = 'Conveyancer',
  EstateAgent = 'EstateAgent',
  MortgageBroker = 'MortgageBroker',
  Surveyor = 'Surveyor'
}

export type BusinessUnion = ConveyancingBusiness;

export type CalculationBreakdown = {
  __typename?: 'CalculationBreakdown';
  items: Array<CalculationResultItem>;
  result: CalculationStatus;
  total?: Maybe<Scalars['Float']['output']>;
};

export type CalculationResultItem = {
  __typename?: 'CalculationResultItem';
  amount: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum CalculationStatus {
  Inconclusive = 'Inconclusive',
  None = 'None',
  Refuse = 'Refuse',
  Success = 'Success'
}

export type ClaimInput = {
  amountJustification: Scalars['String']['input'];
  amountRequested: Scalars['Float']['input'];
  evidence: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CompleteMipInput = {
  amount: Scalars['Int']['input'];
  expiresInMonths: Scalars['Int']['input'];
  issueDate: Scalars['DateTime']['input'];
  issuedToNames: Scalars['String']['input'];
};

export enum Condition {
  Awful = 'Awful',
  Excellent = 'Excellent',
  Good = 'Good',
  Poor = 'Poor'
}

export type ContactDetailsInput = {
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  updateDefaultContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConveyancerSource {
  External = 'External',
  Internal = 'Internal'
}

export type Conveyancing = {
  __typename?: 'Conveyancing';
  id: Scalars['String']['output'];
  primaryContactEmail?: Maybe<Scalars['String']['output']>;
  primaryContactName?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ConveyancingProvider>;
  status: TaskStatus;
};

export type ConveyancingBusiness = {
  __typename?: 'ConveyancingBusiness';
  address: Array<Scalars['String']['output']>;
  awards: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  googlePlacesId: Scalars['String']['output'];
  guarantees: Array<Scalars['String']['output']>;
  hasPortal: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isAcceptingClients: Scalars['Boolean']['output'];
  isDigitalFirst: Scalars['Boolean']['output'];
  isPartner: Scalars['Boolean']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outcode: Scalars['String']['output'];
  premiumPlan?: Maybe<Plan>;
  protectionRating?: Maybe<Scalars['Int']['output']>;
  regulation: ConveyancingRegulator;
  regulationNumber: Scalars['Int']['output'];
  requisitionSummary?: Maybe<RequisitionSummary>;
  standardPlan: Plan;
  trustpilot?: Maybe<TrustpilotSummary>;
  type: BusinessType;
  website: Scalars['String']['output'];
};

export type ConveyancingEstimate = {
  __typename?: 'ConveyancingEstimate';
  breakdown?: Maybe<CalculationBreakdown>;
  calculationType?: Maybe<EstimateCalculationType>;
  conveyancer: ConveyancingBusiness;
  conveyancerId: Scalars['String']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  isArchived: Scalars['Boolean']['output'];
  premiumPlanBreakdown?: Maybe<CalculationBreakdown>;
  premiumPlanCost?: Maybe<Scalars['Float']['output']>;
  recommendationId: Scalars['String']['output'];
  requests: Array<Request>;
};

export type ConveyancingProvider = {
  __typename?: 'ConveyancingProvider';
  defaultEmail: Scalars['String']['output'];
  defaultName: Scalars['String']['output'];
  firm: Scalars['String']['output'];
  id: Scalars['String']['output'];
  source: ConveyancerSource;
};

export type ConveyancingPurchaseDetails = {
  __typename?: 'ConveyancingPurchaseDetails';
  additionalDetails: Array<Scalars['String']['output']>;
  areaOutcode: Scalars['String']['output'];
  buyerCount: Scalars['Int']['output'];
  mortgage?: Maybe<MortgageType>;
  price: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
  tenure: TenureType;
};

export type ConveyancingRecommendation = {
  __typename?: 'ConveyancingRecommendation';
  estimatedAverageCost?: Maybe<Scalars['Int']['output']>;
  estimates: Array<ConveyancingEstimate>;
  id: Scalars['String']['output'];
  priority?: Maybe<PriorityType>;
  purchaseDetails?: Maybe<ConveyancingPurchaseDetails>;
  saleDetails?: Maybe<ConveyancingSaleDetails>;
  situation: ConveyancingSituation;
  urgency?: Maybe<UrgencyType>;
};

export type ConveyancingRecommendations = {
  __typename?: 'ConveyancingRecommendations';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  itemId: Scalars['String']['output'];
  type: ItemType;
  viewedAt: Scalars['Date']['output'];
};

export enum ConveyancingRegulator {
  Clc = 'CLC',
  Sra = 'SRA'
}

export type ConveyancingSaleDetails = {
  __typename?: 'ConveyancingSaleDetails';
  additionalDetails: Array<Scalars['String']['output']>;
  address: Address;
  hasMortgage: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
  sellerCount: Scalars['Int']['output'];
};

export enum ConveyancingSituation {
  Buying = 'Buying',
  Moving = 'Moving',
  Remortgaging = 'Remortgaging',
  Selling = 'Selling'
}

export type CreateAccountInput = {
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  shouldLinkPersonalProfile?: InputMaybe<Scalars['Boolean']['input']>;
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateConeveyancingPurchaseDetailsInput = {
  additionalDetails?: InputMaybe<Array<Scalars['String']['input']>>;
  areaOutcode: Scalars['String']['input'];
  buyerCount: Scalars['Int']['input'];
  mortgage?: InputMaybe<MortgageType>;
  price: Scalars['Float']['input'];
  tenure: TenureType;
};

export type CreateConeveyancingSaleDetailsInput = {
  additionalDetails?: InputMaybe<Array<Scalars['String']['input']>>;
  addressId: Scalars['String']['input'];
  hasMortgage: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  sellerCount: Scalars['Int']['input'];
};

export type CreateConveyancingRecommendationInput = {
  priority?: InputMaybe<PriorityType>;
  purchaseDetails?: InputMaybe<CreateConeveyancingPurchaseDetailsInput>;
  saleDetails?: InputMaybe<CreateConeveyancingSaleDetailsInput>;
  situation: ConveyancingSituation;
  urgency?: InputMaybe<UrgencyType>;
};

export type CreateConveyancingWithProviderInput = {
  firm: Scalars['String']['input'];
  primaryContactEmail: Scalars['String']['input'];
  primaryContactName: Scalars['String']['input'];
};

export type CreateFundingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  source: FundingSourceType;
  totalValue: Scalars['Int']['input'];
};

export type CreateMortgageAdjustmentInput = {
  fromValue: Scalars['Int']['input'];
  toValue: Scalars['Int']['input'];
};

export type CreateOfferInput = {
  coverLetter?: InputMaybe<Scalars['String']['input']>;
  insufficientFundingExplanation?: InputMaybe<Scalars['String']['input']>;
  offerAmount: Scalars['Float']['input'];
  propertyDescription: Scalars['String']['input'];
  purchaseCollectionKey: Scalars['String']['input'];
  sellerEmail: Scalars['Email']['input'];
};

export type CreatePropertySaleInput = {
  estimatedValue?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePurchaseInput = {
  cashAmount: Scalars['Int']['input'];
  isFirstPropertyPurchase: Scalars['Boolean']['input'];
  mortgageAdjustment?: InputMaybe<CreateMortgageAdjustmentInput>;
  name: Scalars['String']['input'];
  otherFunding?: InputMaybe<Array<CreateFundingInput>>;
  propertyOwnedCount: Scalars['Int']['input'];
  propertySales?: InputMaybe<Array<CreatePropertySaleInput>>;
  purchaseCountry: PurchaseCountry;
  purchasePrice: Scalars['Int']['input'];
  purchaseStage?: InputMaybe<PurchaseStage>;
  tenure: TenureType;
};

export type CreateSaleInput = {
  addressId: Scalars['String']['input'];
  estimatedPropertyValue?: InputMaybe<Scalars['Int']['input']>;
  listing?: InputMaybe<ListingInput>;
  propertyPurchases?: InputMaybe<Array<PropertyPurchaseInput>>;
  tenure?: InputMaybe<TenureType>;
};

export type DeclineReservationAgreementInput = {
  name: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum Defects {
  Cosmetic = 'Cosmetic',
  Major = 'Major',
  None = 'None',
  Substantial = 'Substantial'
}

export enum DocType {
  Leasehold = 'Leasehold',
  Unknown = 'Unknown'
}

export enum EstimateCalculationType {
  Average = 'Average',
  Rules = 'Rules'
}

export type File = {
  __typename?: 'File';
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<FileType>;
  url: Scalars['String']['output'];
};

export enum FileType {
  Leasehold = 'Leasehold',
  MortgageInPrinciple = 'MortgageInPrinciple'
}

export type Funding = {
  __typename?: 'Funding';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  source: FundingSourceType;
  totalValue: Scalars['Int']['output'];
};

export enum FundingSourceType {
  AssetSale = 'AssetSale',
  Gift = 'Gift',
  Other = 'Other'
}

export enum ItemType {
  ConveyancingRecommendation = 'ConveyancingRecommendation',
  ProtectOwner = 'ProtectOwner',
  ProtectReceiver = 'ProtectReceiver'
}

export type ItemUnion = ConveyancingRecommendations | PersonalProtectPolicies | ProtectInvitations;

export type Kyc = {
  __typename?: 'Kyc';
  address?: Maybe<Address>;
  dob: Scalars['DateOnlyString']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  middleNames?: Maybe<Scalars['String']['output']>;
  personalProfile: PersonalProfile;
  userIdentityCheck?: Maybe<UserIdentityCheck>;
};

export enum KycReportStatus {
  Clear = 'Clear',
  Consider = 'Consider',
  Pending = 'Pending'
}

export type KycSessionModel = {
  __typename?: 'KycSessionModel';
  expiration: Scalars['Date']['output'];
  token: Scalars['String']['output'];
};

export enum KycStatus {
  AdditionalInfoRequested = 'AdditionalInfoRequested',
  Clear = 'Clear',
  Consider = 'Consider',
  Pending = 'Pending',
  Withdrawn = 'Withdrawn'
}

export type LeaseholdQuestion = {
  __typename?: 'LeaseholdQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  clause?: Maybe<Scalars['String']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  page?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  questionKey: LeaseholdQuestionKey;
  result: LeaseholdQuestionResult;
};

export enum LeaseholdQuestionKey {
  AlterationConsent = 'AlterationConsent',
  Ews1 = 'Ews1',
  ExtendsTerm = 'ExtendsTerm',
  Freehold = 'Freehold',
  GroundRents = 'GroundRents',
  Insurance = 'Insurance',
  OutdoorSpace = 'OutdoorSpace',
  Parking = 'Parking',
  PetsAllowed = 'PetsAllowed',
  RentProperty = 'RentProperty',
  ReserveFund = 'ReserveFund'
}

export enum LeaseholdQuestionResult {
  Inconclusive = 'Inconclusive',
  No = 'No',
  Pending = 'Pending',
  YesHighConfidence = 'YesHighConfidence',
  YesLowConfidence = 'YesLowConfidence'
}

export type LeaseholdReview = {
  __typename?: 'LeaseholdReview';
  aiDocReview: AiDocReview;
  id: Scalars['Int']['output'];
  questions: Array<LeaseholdQuestion>;
};

export type LeaseholdReviewInput = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type LeaseholdReviewReportMistakeInput = {
  leaseholdReviewId: Scalars['Float']['input'];
  questionKey: Scalars['String']['input'];
};

export type Listing = {
  __typename?: 'Listing';
  id: Scalars['Int']['output'];
  listingUrl?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type ListingInput = {
  listingUrl?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type MakeRequestInput = {
  allowBusinessContact?: InputMaybe<Scalars['Boolean']['input']>;
  contactDetails: ContactDetailsInput;
  type: RequestType;
};

export type Mip = {
  __typename?: 'Mip';
  amount?: Maybe<Scalars['Int']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<File>;
  id: Scalars['String']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  issuedToNames?: Maybe<Scalars['String']['output']>;
  personalProfile: PersonalProfile;
  providerName?: Maybe<Scalars['String']['output']>;
  status: TaskStatus;
};

export type MortgageAdjustment = {
  __typename?: 'MortgageAdjustment';
  fromValue: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  toValue: Scalars['Int']['output'];
};

export enum MortgageType {
  BuyToLet = 'BuyToLet',
  Residential = 'Residential'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptOffer: Scalars['Boolean']['output'];
  acceptReservationAgreement: Scalars['Boolean']['output'];
  addFundingToPurchase: Purchase;
  addPropertySaleToPurchase: Purchase;
  bookSurvey: Survey;
  claimPersonalProfile: Scalars['String']['output'];
  confirmAcceptanceOfReservationAgreement: Scalars['Boolean']['output'];
  confirmReservationAgreementPaymentMade: Scalars['Boolean']['output'];
  createConveyancing: Conveyancing;
  createConveyancingRecommendation: ConveyancingRecommendation;
  createConveyancingWithProvider: Conveyancing;
  createDraftReservationAgreement: ReservationAgreement;
  createExternalMip: Mip;
  createKycSession: KycSessionModel;
  createMip: Mip;
  createOffer: Offer;
  createPurchase: Purchase;
  createSale: Sale;
  declineOffer: Scalars['Boolean']['output'];
  declineReservationAgreement: Scalars['Boolean']['output'];
  dismissReservationAgreementRejection: Scalars['Boolean']['output'];
  leasholdReview: LeaseholdReview;
  logout: Scalars['Boolean']['output'];
  makeConveyancingRequest: ConveyancingEstimate;
  negotiateReservationAgreement: Scalars['Boolean']['output'];
  recordLeaseholdReviewMistake: Scalars['Boolean']['output'];
  removePurchaseFunding: Purchase;
  removePurchasePropertySale: Purchase;
  requestSignIn: Scalars['String']['output'];
  requestSignUp: Scalars['String']['output'];
  requestVerifyEmailLink: Scalars['Boolean']['output'];
  setMiPComplete: Mip;
  submitClaim: Scalars['Boolean']['output'];
  submitKycUserIdentityChecks: Scalars['Boolean']['output'];
  submitOffer: ReservationAgreement;
  updateLegalInfo: Scalars['Boolean']['output'];
  updateMip: Mip;
  updateMortgageAdjustment: Purchase;
  updatePurchase: Purchase;
  updatePurchaseFunding: Purchase;
  updateReservationAgreementPolicy: ReservationAgreement;
  updateReservationAgreementProfile: ReservationAgreement;
  upgradeToFullAccount: PersonalProfile;
};


export type MutationAcceptOfferArgs = {
  offerId: Scalars['Int']['input'];
};


export type MutationAcceptReservationAgreementArgs = {
  data: AcceptReservationAgreementInput;
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationAddFundingToPurchaseArgs = {
  collectionKey: Scalars['String']['input'];
  funding: CreateFundingInput;
};


export type MutationAddPropertySaleToPurchaseArgs = {
  collectionKey: Scalars['String']['input'];
  propertySale: CreatePropertySaleInput;
};


export type MutationBookSurveyArgs = {
  data: SurveyInput;
};


export type MutationConfirmAcceptanceOfReservationAgreementArgs = {
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationConfirmReservationAgreementPaymentMadeArgs = {
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationCreateConveyancingArgs = {
  collectionKey: Scalars['String']['input'];
  status?: InputMaybe<TaskStatus>;
};


export type MutationCreateConveyancingRecommendationArgs = {
  data: CreateConveyancingRecommendationInput;
};


export type MutationCreateConveyancingWithProviderArgs = {
  collectionKey: Scalars['String']['input'];
  data: CreateConveyancingWithProviderInput;
};


export type MutationCreateDraftReservationAgreementArgs = {
  data: ReservationAgreementInput;
};


export type MutationCreateExternalMipArgs = {
  collectionKey: Scalars['String']['input'];
};


export type MutationCreateMipArgs = {
  collectionKey: Scalars['String']['input'];
};


export type MutationCreateOfferArgs = {
  offer: CreateOfferInput;
};


export type MutationCreatePurchaseArgs = {
  purchase: CreatePurchaseInput;
};


export type MutationCreateSaleArgs = {
  sale: CreateSaleInput;
};


export type MutationDeclineOfferArgs = {
  offerId: Scalars['Int']['input'];
};


export type MutationDeclineReservationAgreementArgs = {
  data: DeclineReservationAgreementInput;
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationDismissReservationAgreementRejectionArgs = {
  rejectionId: Scalars['Float']['input'];
};


export type MutationLeasholdReviewArgs = {
  collectionKey?: InputMaybe<Scalars['String']['input']>;
  data: LeaseholdReviewInput;
};


export type MutationMakeConveyancingRequestArgs = {
  conveyancerId: Scalars['String']['input'];
  recommendationId: Scalars['String']['input'];
  request: MakeRequestInput;
};


export type MutationNegotiateReservationAgreementArgs = {
  data: NegotiateReservationAgreementInput;
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationRecordLeaseholdReviewMistakeArgs = {
  data: LeaseholdReviewReportMistakeInput;
};


export type MutationRemovePurchaseFundingArgs = {
  collectionKey: Scalars['String']['input'];
  fundingId: Scalars['Float']['input'];
};


export type MutationRemovePurchasePropertySaleArgs = {
  collectionKey: Scalars['String']['input'];
  propertySaleId: Scalars['Float']['input'];
};


export type MutationRequestSignInArgs = {
  email: Scalars['Email']['input'];
};


export type MutationRequestSignUpArgs = {
  userDetails: CreateAccountInput;
};


export type MutationRequestVerifyEmailLinkArgs = {
  verifyEmail: VerifyEmailInput;
};


export type MutationSetMiPCompleteArgs = {
  data: CompleteMipInput;
  id: Scalars['String']['input'];
};


export type MutationSubmitClaimArgs = {
  claim: ClaimInput;
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationSubmitOfferArgs = {
  data: ReservationAgreementResponseInput;
  reservationAgreementId: Scalars['String']['input'];
};


export type MutationUpdateLegalInfoArgs = {
  legalInfo: UserLegalInfoInput;
};


export type MutationUpdateMipArgs = {
  data: UpdateMipInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateMortgageAdjustmentArgs = {
  collectionKey: Scalars['String']['input'];
  mortgageAdjustment: UpdateMortgageAdjustmentInput;
};


export type MutationUpdatePurchaseArgs = {
  collectionKey: Scalars['String']['input'];
  purchase: UpdatePurchaseInput;
};


export type MutationUpdatePurchaseFundingArgs = {
  collectionKey: Scalars['String']['input'];
  funding: UpdateFundingInput;
  fundingId: Scalars['Float']['input'];
};


export type MutationUpgradeToFullAccountArgs = {
  userDetails: UpgradeAccountInput;
};

export type NegotiateReservationAgreementInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  template: ReservationAgreementTermsInput;
};

export type Offer = {
  __typename?: 'Offer';
  coverLetter?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  insufficientFundingExplanation?: Maybe<Scalars['String']['output']>;
  offerAmount: Scalars['Float']['output'];
  offerStatus: OfferStatus;
  propertyDescription: Scalars['String']['output'];
  purchase: Purchase;
  reservationAgreement?: Maybe<ReservationAgreement>;
};

export enum OfferStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
  Submitted = 'Submitted',
  Withdrawn = 'Withdrawn'
}

export type Partner = {
  __typename?: 'Partner';
  business?: Maybe<BusinessUnion>;
  domain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
};

export type PersonalProfile = {
  __typename?: 'PersonalProfile';
  businesses: Array<Partner>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  kyc?: Maybe<Kyc>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  purchases: Array<Purchase>;
  referralCode: Scalars['String']['output'];
  referralCount: Scalars['Int']['output'];
  referralEarned: Scalars['Int']['output'];
  referralPaid: Scalars['Int']['output'];
  sales: Array<Sale>;
};

export type PersonalProtectPolicies = {
  __typename?: 'PersonalProtectPolicies';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  itemId: Scalars['String']['output'];
  type: ItemType;
  viewedAt: Scalars['Date']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  cashback?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  percentageFromAverage?: Maybe<Scalars['Float']['output']>;
  priceRating?: Maybe<Scalars['Float']['output']>;
};

export enum PriorityType {
  Price = 'Price',
  Service = 'Service',
  Speed = 'Speed'
}

export type Property = {
  __typename?: 'Property';
  additionalDetails: Array<Scalars['String']['output']>;
  address: Address;
  ageRange?: Maybe<AgeRange>;
  bedroomCount: Scalars['Int']['output'];
  condition?: Maybe<Condition>;
  defects?: Maybe<Defects>;
  hasMortgage?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  outcode?: Maybe<Scalars['String']['output']>;
  ownerCount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  renovationPlans?: Maybe<RenovationPlans>;
  specialistConstruction?: Maybe<SpecialistConstruction>;
  tenure?: Maybe<TenureType>;
  type?: Maybe<PropertyType>;
};

export type PropertyPurchase = {
  __typename?: 'PropertyPurchase';
  estimatedValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type PropertyPurchaseInput = {
  estimatedValue?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertySale = {
  __typename?: 'PropertySale';
  estimatedValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export enum PropertyType {
  DetachedHouse = 'DetachedHouse',
  Flat = 'Flat',
  SemiDetachedHouse = 'SemiDetachedHouse',
  TerracedHouse = 'TerracedHouse'
}

export type ProtectInvitations = {
  __typename?: 'ProtectInvitations';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  itemId: Scalars['String']['output'];
  type: ItemType;
  viewedAt: Scalars['Date']['output'];
};

export type Purchase = {
  __typename?: 'Purchase';
  cashAmount: Scalars['Int']['output'];
  collectionKey: Scalars['String']['output'];
  conveyancing?: Maybe<Conveyancing>;
  createdAt: Scalars['DateTime']['output'];
  files: Array<File>;
  isFirstPropertyPurchase: Scalars['Boolean']['output'];
  mortgageAdjustment?: Maybe<MortgageAdjustment>;
  mortgageInPrinciple?: Maybe<Mip>;
  name: Scalars['String']['output'];
  otherFunding: Array<Funding>;
  propertyOwnedCount: Scalars['Int']['output'];
  propertySales: Array<PropertySale>;
  purchaseCountry: PurchaseCountry;
  purchasePrice: Scalars['Int']['output'];
  purchaseStage?: Maybe<PurchaseStage>;
  tenure: TenureType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PurchaseCountry {
  England = 'England',
  NorthernIreland = 'NorthernIreland',
  Scotland = 'Scotland',
  Wales = 'Wales'
}

export enum PurchaseStage {
  ActiveSearch = 'ActiveSearch',
  BrowsingForFuture = 'BrowsingForFuture',
  OfferAccepted = 'OfferAccepted',
  OfferMade = 'OfferMade',
  Start = 'Start'
}

export type Query = {
  __typename?: 'Query';
  address: Address;
  authStatus: AuthStatus;
  conveyancing: Conveyancing;
  conveyancingRecommendation: ConveyancingRecommendation;
  currentProfile?: Maybe<Partner>;
  getReservationAgreement?: Maybe<ReservationAgreement>;
  items: Array<ItemUnion>;
  kyc?: Maybe<Kyc>;
  leaseholdReview: LeaseholdReview;
  mip: Mip;
  mips: Array<Mip>;
  offer?: Maybe<Offer>;
  purchase: Purchase;
  purchases: Array<Purchase>;
  sale: Sale;
  sales: Array<Sale>;
  self?: Maybe<PersonalProfile>;
};


export type QueryAddressArgs = {
  id: Scalars['String']['input'];
};


export type QueryConveyancingArgs = {
  id: Scalars['String']['input'];
};


export type QueryConveyancingRecommendationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetReservationAgreementArgs = {
  id: Scalars['String']['input'];
};


export type QueryLeaseholdReviewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMipArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPurchaseArgs = {
  collectionKey: Scalars['String']['input'];
};


export type QuerySaleArgs = {
  collectionKey: Scalars['String']['input'];
};

export enum RenovationPlans {
  Cosmetic = 'Cosmetic',
  Demolition = 'Demolition',
  None = 'None',
  Structural = 'Structural'
}

export type Report = {
  __typename?: 'Report';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Request = {
  __typename?: 'Request';
  allowBusinessContact: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  status: RequestStatus;
  type: RequestType;
};

export enum RequestStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Pending = 'Pending'
}

export enum RequestType {
  Callback = 'Callback',
  Instruction = 'Instruction',
  Quote = 'Quote'
}

export type RequisitionSummary = {
  __typename?: 'RequisitionSummary';
  inaccuracyPercentage: Scalars['Float']['output'];
  inaccuracyRating: Scalars['Float']['output'];
  totalRequisitionRequests: Scalars['Float']['output'];
  totalSubmissionCount: Scalars['Float']['output'];
};

export type ReservationAgreement = {
  __typename?: 'ReservationAgreement';
  additionalConditions?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  createdAt: Scalars['Date']['output'];
  depositAmountInPounds: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isTheirKycComplete: Scalars['Boolean']['output'];
  isTheirPaymentMade: Scalars['Boolean']['output'];
  isYourKycComplete: Scalars['Boolean']['output'];
  isYourPaymentMade: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  rejections?: Maybe<Array<ReservationAgreementRejection>>;
  stage: ReservationAgreementStage;
  theirFullName?: Maybe<Scalars['String']['output']>;
  theirResponse?: Maybe<ResponseType>;
  theirSide: TransactionSide;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  viewMode: ReservationAgreementViewMode;
  yourFullName?: Maybe<Scalars['String']['output']>;
  yourResponse?: Maybe<ResponseType>;
  yourSide: TransactionSide;
};

export type ReservationAgreementInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  ownerSide: TransactionSide;
  template: ReservationAgreementTermsInput;
};

export type ReservationAgreementRejection = {
  __typename?: 'ReservationAgreementRejection';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type ReservationAgreementResponseInput = {
  counterTerms?: InputMaybe<ReservationAgreementTermsInput>;
  previousOfferId?: InputMaybe<Scalars['Int']['input']>;
  response: ResponseType;
  side: TransactionSide;
};

export enum ReservationAgreementStage {
  Active = 'Active',
  Complete = 'Complete',
  Confirming = 'Confirming',
  Declined = 'Declined',
  Draft = 'Draft',
  Onboarding = 'Onboarding',
  Proposal = 'Proposal',
  Unavailable = 'Unavailable'
}

export type ReservationAgreementTermsInput = {
  additionalConditions?: InputMaybe<Scalars['String']['input']>;
  depositAmountInPounds: Scalars['Int']['input'];
};

export enum ReservationAgreementViewMode {
  Participant = 'Participant',
  Visitor = 'Visitor'
}

export enum ResponseType {
  Accept = 'Accept',
  Counter = 'Counter',
  Decline = 'Decline'
}

export type Sale = {
  __typename?: 'Sale';
  address: Address;
  collectionKey: Scalars['String']['output'];
  estimatedPropertyValue?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<Listing>;
  name: Scalars['String']['output'];
  propertyPurchases: Array<PropertyPurchase>;
  tenure: TenureType;
};

export enum SpecialistConstruction {
  BarnOrChurchConversion = 'BarnOrChurchConversion',
  LargeExtension = 'LargeExtension',
  ListedBuilding = 'ListedBuilding',
  SpecialistMaterials = 'SpecialistMaterials',
  SteelFrame = 'SteelFrame',
  ThatchedRoof = 'ThatchedRoof'
}

export type Survey = {
  __typename?: 'Survey';
  accessName: Scalars['String']['output'];
  accessPhoneNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  property: Property;
  status: RequestStatus;
  type: SurveyType;
};

export type SurveyInput = {
  accessName: Scalars['String']['input'];
  accessPhoneNumber: Scalars['String']['input'];
  contactDetails: ContactDetailsInput;
  propertyDetails: SurveyPropertyDetailsInput;
  quotedPrice?: InputMaybe<Scalars['Int']['input']>;
  surveyType: SurveyType;
};

export type SurveyPropertyDetailsInput = {
  addressId: Scalars['String']['input'];
  ageRange: AgeRange;
  bedroomCount: Scalars['Int']['input'];
  condition: Condition;
  defects: Defects;
  id?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  renovationPlans: RenovationPlans;
  specialistConstruction: Array<SpecialistConstruction>;
  type: PropertyType;
};

export enum SurveyType {
  Asbestos = 'Asbestos',
  CctvDrain = 'CctvDrain',
  DampAndTimber = 'DampAndTimber',
  Electrical = 'Electrical',
  Gas = 'Gas',
  HomeServices = 'HomeServices',
  JapaneseKnotweed = 'JapaneseKnotweed',
  Level2 = 'Level2',
  Level2WithValuation = 'Level2WithValuation',
  Level3 = 'Level3',
  Level3WithValuation = 'Level3WithValuation',
  Roof = 'Roof',
  StructuralEngineers = 'StructuralEngineers',
  Tree = 'Tree',
  WallTie = 'WallTie'
}

export enum TaskStatus {
  Complete = 'Complete',
  NotApplicable = 'NotApplicable',
  NotStarted = 'NotStarted',
  Pending = 'Pending'
}

export enum TenureType {
  Commonhold = 'Commonhold',
  Freehold = 'Freehold',
  Leasehold = 'Leasehold',
  NonTraditional = 'NonTraditional',
  ShareOfFreehold = 'ShareOfFreehold',
  SharedOwnership = 'SharedOwnership',
  Unknown = 'Unknown'
}

export enum TransactionSide {
  Purchase = 'Purchase',
  Sale = 'Sale'
}

export type TrustpilotSummary = {
  __typename?: 'TrustpilotSummary';
  id: Scalars['String']['output'];
  reviews: Scalars['Float']['output'];
  stars: Scalars['Float']['output'];
};

export type UpdateFundingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  source: FundingSourceType;
  totalValue: Scalars['Int']['input'];
};

export type UpdateMipInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuedToNames?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
};

export type UpdateMortgageAdjustmentInput = {
  fromValue: Scalars['Int']['input'];
  toValue: Scalars['Int']['input'];
};

export type UpdatePurchaseInput = {
  cashAmount?: InputMaybe<Scalars['Int']['input']>;
  isFirstPropertyPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyOwnedCount?: InputMaybe<Scalars['Int']['input']>;
  purchaseCountry?: InputMaybe<PurchaseCountry>;
  purchasePrice?: InputMaybe<Scalars['Int']['input']>;
  purchaseStage?: InputMaybe<PurchaseStage>;
  tenure?: InputMaybe<TenureType>;
};

export type UpgradeAccountInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UrgencyType {
  JustBrowsing = 'JustBrowsing',
  Now = 'Now',
  Soon = 'Soon'
}

export type UserIdentityCheck = {
  __typename?: 'UserIdentityCheck';
  checkStatus: KycStatus;
  documentationReportStatus?: Maybe<KycReportStatus>;
  duplicateUserReportStatus?: Maybe<KycReportStatus>;
  facialMatchReportStatus?: Maybe<KycReportStatus>;
  id: Scalars['String']['output'];
  kycId: Scalars['Int']['output'];
  reports: Array<Report>;
  watchlistReportStatus?: Maybe<KycReportStatus>;
};

export type UserLegalInfoInput = {
  addressId: Scalars['String']['input'];
  dob: Scalars['DateOnlyString']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleNames?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyEmailInput = {
  email: Scalars['Email']['input'];
  redirectRelativeUrl: Scalars['String']['input'];
};

export type AcceptOfferMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
}>;


export type AcceptOfferMutation = { __typename?: 'Mutation', acceptOffer: boolean };

export type AcceptReservationAgreementMutationVariables = Exact<{
  reservationAgreementId: Scalars['String']['input'];
  data: AcceptReservationAgreementInput;
}>;


export type AcceptReservationAgreementMutation = { __typename?: 'Mutation', isSuccessul: boolean };

export type AddFundingToPurchaseMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  funding: CreateFundingInput;
}>;


export type AddFundingToPurchaseMutation = { __typename?: 'Mutation', addFundingToPurchase: { __typename?: 'Purchase', collectionKey: string, createdAt: any, updatedAt: any, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number }> } };

export type AddPropertySaleToPurchaseMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  propertySale: CreatePropertySaleInput;
}>;


export type AddPropertySaleToPurchaseMutation = { __typename?: 'Mutation', addPropertySaleToPurchase: { __typename?: 'Purchase', collectionKey: string, propertySales: Array<{ __typename?: 'PropertySale', id: number, estimatedValue?: number | null }> } };

export type AuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthStatusQuery = { __typename?: 'Query', authStatus: AuthStatus };

export type BasicAddressFragment = { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null };

export type ConfirmAcceptanceOfReservationAgreementMutationVariables = Exact<{
  reservationAgreementId: Scalars['String']['input'];
}>;


export type ConfirmAcceptanceOfReservationAgreementMutation = { __typename?: 'Mutation', isSuccessful: boolean };

export type ConfirmReservationAgreementPaymentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConfirmReservationAgreementPaymentMutation = { __typename?: 'Mutation', isConfirmed: boolean };

export type ConveyancingBusinessBasicInfoFragment = { __typename?: 'ConveyancingBusiness', id: string, name: string, logoUrl: string, website: string, description: string, isAcceptingClients: boolean, outcode: string, address: Array<string>, googlePlacesId: string, regulation: ConveyancingRegulator, regulationNumber: number, protectionRating?: number | null, trustpilot?: { __typename?: 'TrustpilotSummary', id: string, stars: number, reviews: number } | null };

export type ConveyancingEstimateFragment = { __typename?: 'ConveyancingEstimate', recommendationId: string, conveyancerId: string, isArchived: boolean, cost?: number | null, conveyancer: { __typename?: 'ConveyancingBusiness', id: string, name: string, logoUrl: string, website: string, description: string, isAcceptingClients: boolean, outcode: string, address: Array<string>, googlePlacesId: string, regulation: ConveyancingRegulator, regulationNumber: number, protectionRating?: number | null, standardPlan: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null }, premiumPlan?: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null } | null, requisitionSummary?: { __typename?: 'RequisitionSummary', inaccuracyRating: number, inaccuracyPercentage: number, totalSubmissionCount: number, totalRequisitionRequests: number } | null, trustpilot?: { __typename?: 'TrustpilotSummary', id: string, stars: number, reviews: number } | null }, requests: Array<{ __typename?: 'Request', id: string, type: RequestType, status: RequestStatus }> };

export type ConveyancingRecommendationFragment = { __typename?: 'ConveyancingRecommendation', id: string, situation: ConveyancingSituation, urgency?: UrgencyType | null, priority?: PriorityType | null, estimatedAverageCost?: number | null, estimates: Array<{ __typename?: 'ConveyancingEstimate', recommendationId: string, conveyancerId: string, isArchived: boolean, cost?: number | null, conveyancer: { __typename?: 'ConveyancingBusiness', id: string, name: string, logoUrl: string, website: string, description: string, isAcceptingClients: boolean, outcode: string, address: Array<string>, googlePlacesId: string, regulation: ConveyancingRegulator, regulationNumber: number, protectionRating?: number | null, standardPlan: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null }, premiumPlan?: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null } | null, requisitionSummary?: { __typename?: 'RequisitionSummary', inaccuracyRating: number, inaccuracyPercentage: number, totalSubmissionCount: number, totalRequisitionRequests: number } | null, trustpilot?: { __typename?: 'TrustpilotSummary', id: string, stars: number, reviews: number } | null }, requests: Array<{ __typename?: 'Request', id: string, type: RequestType, status: RequestStatus }> }>, purchaseDetails?: { __typename?: 'ConveyancingPurchaseDetails', requestId: string, price: number, mortgage?: MortgageType | null, buyerCount: number, tenure: TenureType, areaOutcode: string, additionalDetails: Array<string> } | null, saleDetails?: { __typename?: 'ConveyancingSaleDetails', requestId: string, price: number, sellerCount: number, hasMortgage: boolean, additionalDetails: Array<string>, address: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } } | null };

export type ConveyancingRequestFragment = { __typename?: 'Request', id: string, type: RequestType, status: RequestStatus };

export type CreateConveyancingRecommendationMutationVariables = Exact<{
  data: CreateConveyancingRecommendationInput;
}>;


export type CreateConveyancingRecommendationMutation = { __typename?: 'Mutation', conveyancingRecommendation: { __typename?: 'ConveyancingRecommendation', id: string, situation: ConveyancingSituation, urgency?: UrgencyType | null, priority?: PriorityType | null, estimatedAverageCost?: number | null, estimates: Array<{ __typename?: 'ConveyancingEstimate', recommendationId: string, conveyancerId: string, isArchived: boolean, cost?: number | null, conveyancer: { __typename?: 'ConveyancingBusiness', id: string, name: string, logoUrl: string, website: string, description: string, isAcceptingClients: boolean, outcode: string, address: Array<string>, googlePlacesId: string, regulation: ConveyancingRegulator, regulationNumber: number, protectionRating?: number | null, standardPlan: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null }, premiumPlan?: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null } | null, requisitionSummary?: { __typename?: 'RequisitionSummary', inaccuracyRating: number, inaccuracyPercentage: number, totalSubmissionCount: number, totalRequisitionRequests: number } | null, trustpilot?: { __typename?: 'TrustpilotSummary', id: string, stars: number, reviews: number } | null }, requests: Array<{ __typename?: 'Request', id: string, type: RequestType, status: RequestStatus }> }>, purchaseDetails?: { __typename?: 'ConveyancingPurchaseDetails', requestId: string, price: number, mortgage?: MortgageType | null, buyerCount: number, tenure: TenureType, areaOutcode: string, additionalDetails: Array<string> } | null, saleDetails?: { __typename?: 'ConveyancingSaleDetails', requestId: string, price: number, sellerCount: number, hasMortgage: boolean, additionalDetails: Array<string>, address: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } } | null } };

export type ConveyancingRecommendationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConveyancingRecommendationQuery = { __typename?: 'Query', conveyancingRecommendation: { __typename?: 'ConveyancingRecommendation', id: string, situation: ConveyancingSituation, urgency?: UrgencyType | null, priority?: PriorityType | null, estimatedAverageCost?: number | null, estimates: Array<{ __typename?: 'ConveyancingEstimate', recommendationId: string, conveyancerId: string, isArchived: boolean, cost?: number | null, conveyancer: { __typename?: 'ConveyancingBusiness', id: string, name: string, logoUrl: string, website: string, description: string, isAcceptingClients: boolean, outcode: string, address: Array<string>, googlePlacesId: string, regulation: ConveyancingRegulator, regulationNumber: number, protectionRating?: number | null, standardPlan: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null }, premiumPlan?: { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null } | null, requisitionSummary?: { __typename?: 'RequisitionSummary', inaccuracyRating: number, inaccuracyPercentage: number, totalSubmissionCount: number, totalRequisitionRequests: number } | null, trustpilot?: { __typename?: 'TrustpilotSummary', id: string, stars: number, reviews: number } | null }, requests: Array<{ __typename?: 'Request', id: string, type: RequestType, status: RequestStatus }> }>, purchaseDetails?: { __typename?: 'ConveyancingPurchaseDetails', requestId: string, price: number, mortgage?: MortgageType | null, buyerCount: number, tenure: TenureType, areaOutcode: string, additionalDetails: Array<string> } | null, saleDetails?: { __typename?: 'ConveyancingSaleDetails', requestId: string, price: number, sellerCount: number, hasMortgage: boolean, additionalDetails: Array<string>, address: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } } | null } };

export type MakeConveyancingRequestMutationVariables = Exact<{
  recommendationId: Scalars['String']['input'];
  conveyancerId: Scalars['String']['input'];
  request: MakeRequestInput;
}>;


export type MakeConveyancingRequestMutation = { __typename?: 'Mutation', makeConveyancingRequest: { __typename?: 'ConveyancingEstimate', recommendationId: string, conveyancerId: string, requests: Array<{ __typename?: 'Request', id: string, type: RequestType, status: RequestStatus }> } };

export type CreateDraftProtectPolicyMutationVariables = Exact<{
  data: ReservationAgreementInput;
}>;


export type CreateDraftProtectPolicyMutation = { __typename?: 'Mutation', draftPolicy: { __typename?: 'ReservationAgreement', id: string, stage: ReservationAgreementStage, viewMode: ReservationAgreementViewMode, reason?: string | null, yourSide: TransactionSide, yourFullName?: string | null, yourResponse?: ResponseType | null, isYourPaymentMade: boolean, isYourKycComplete: boolean, theirSide: TransactionSide, theirFullName?: string | null, theirResponse?: ResponseType | null, isTheirPaymentMade: boolean, isTheirKycComplete: boolean, depositAmountInPounds: number, additionalConditions?: string | null, address?: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } | null, rejections?: Array<{ __typename?: 'ReservationAgreementRejection', id: number, name: string, reason?: string | null, createdAt: any }> | null } };

export type CreateExternalMipMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
}>;


export type CreateExternalMipMutation = { __typename?: 'Mutation', createExternalMip: { __typename?: 'Mip', id: string } };

export type CreateKycSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateKycSessionMutation = { __typename?: 'Mutation', createKycSession: { __typename?: 'KycSessionModel', token: string, expiration: any } };

export type CreateMiPMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
}>;


export type CreateMiPMutation = { __typename?: 'Mutation', createMip: { __typename?: 'Mip', id: string } };

export type CreatePurchaseMutationVariables = Exact<{
  purchase: CreatePurchaseInput;
}>;


export type CreatePurchaseMutation = { __typename?: 'Mutation', createPurchase: { __typename?: 'Purchase', collectionKey: string, name: string, purchasePrice: number, purchaseStage?: PurchaseStage | null, cashAmount: number, purchaseCountry: PurchaseCountry, tenure: TenureType, isFirstPropertyPurchase: boolean, propertyOwnedCount: number, createdAt: any, updatedAt: any, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number, description?: string | null }>, propertySales: Array<{ __typename?: 'PropertySale', id: number, estimatedValue?: number | null }>, mortgageAdjustment?: { __typename?: 'MortgageAdjustment', id: number, fromValue: number, toValue: number } | null, mortgageInPrinciple?: { __typename?: 'Mip', id: string, status: TaskStatus } | null, conveyancing?: { __typename?: 'Conveyancing', status: TaskStatus } | null, files: Array<{ __typename?: 'File', id: string, name: string, url: string, mimeType: string }> } };

export type CreateSaleMutationVariables = Exact<{
  sale: CreateSaleInput;
}>;


export type CreateSaleMutation = { __typename?: 'Mutation', createSale: { __typename?: 'Sale', collectionKey: string, estimatedPropertyValue?: number | null, tenure: TenureType, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, postcode: string, city: string }, listing?: { __typename?: 'Listing', id: number, price?: number | null, listingUrl?: string | null } | null, propertyPurchases: Array<{ __typename?: 'PropertyPurchase', id: number, estimatedValue?: number | null }> } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', authStatus: AuthStatus, currentProfile?: { __typename?: 'Partner', id: string, name: string, logoUrl: string } | null, self?: { __typename?: 'PersonalProfile', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, preferredName?: string | null, referralCode: string, referralCount: number, referralEarned: number, referralPaid: number, kyc?: { __typename?: 'Kyc', id: number } | null, purchases: Array<{ __typename?: 'Purchase', collectionKey: string, name: string }>, sales: Array<{ __typename?: 'Sale', collectionKey: string, name: string }>, businesses: Array<{ __typename?: 'Partner', id: string, name: string, logoUrl: string }> } | null, items: Array<{ __typename: 'ConveyancingRecommendations', itemId: string } | { __typename: 'PersonalProtectPolicies', itemId: string } | { __typename: 'ProtectInvitations', itemId: string }> };

export type DeclineOfferMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
}>;


export type DeclineOfferMutation = { __typename?: 'Mutation', declineOffer: boolean };

export type DeclineReservationAgreementMutationVariables = Exact<{
  reservationAgreementId: Scalars['String']['input'];
  data: DeclineReservationAgreementInput;
}>;


export type DeclineReservationAgreementMutation = { __typename?: 'Mutation', isDeclined: boolean };

export type DismissReservationAgreementRejectionMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DismissReservationAgreementRejectionMutation = { __typename?: 'Mutation', isDismissed: boolean };

export type ConveyancingPlanFragment = { __typename?: 'Plan', id: string, name: string, logoUrl?: string | null, description?: string | null, percentageFromAverage?: number | null, priceRating?: number | null, cashback?: number | null };

export type RequisitionSummaryFragment = { __typename?: 'RequisitionSummary', inaccuracyRating: number, inaccuracyPercentage: number, totalSubmissionCount: number, totalRequisitionRequests: number };

export type FullPurchaseFragment = { __typename?: 'Purchase', collectionKey: string, name: string, purchasePrice: number, purchaseStage?: PurchaseStage | null, cashAmount: number, purchaseCountry: PurchaseCountry, tenure: TenureType, isFirstPropertyPurchase: boolean, propertyOwnedCount: number, createdAt: any, updatedAt: any, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number, description?: string | null }>, propertySales: Array<{ __typename?: 'PropertySale', id: number, estimatedValue?: number | null }>, mortgageAdjustment?: { __typename?: 'MortgageAdjustment', id: number, fromValue: number, toValue: number } | null, mortgageInPrinciple?: { __typename?: 'Mip', id: string, status: TaskStatus } | null, conveyancing?: { __typename?: 'Conveyancing', status: TaskStatus } | null, files: Array<{ __typename?: 'File', id: string, name: string, url: string, mimeType: string }> };

export type FullSaleFragment = { __typename?: 'Sale', collectionKey: string, estimatedPropertyValue?: number | null, tenure: TenureType, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, postcode: string, city: string }, listing?: { __typename?: 'Listing', id: number, price?: number | null, listingUrl?: string | null } | null, propertyPurchases: Array<{ __typename?: 'PropertyPurchase', id: number, estimatedValue?: number | null }> };

export type GetAddressQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAddressQuery = { __typename?: 'Query', address: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } };

export type GetKycUserIdentityCheckStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKycUserIdentityCheckStatusQuery = { __typename?: 'Query', kyc?: { __typename?: 'Kyc', id: number, firstName: string, lastName: string, middleNames?: string | null, dob: any, userIdentityCheck?: { __typename?: 'UserIdentityCheck', id: string, checkStatus: KycStatus, documentationReportStatus?: KycReportStatus | null, duplicateUserReportStatus?: KycReportStatus | null, facialMatchReportStatus?: KycReportStatus | null, watchlistReportStatus?: KycReportStatus | null } | null, address?: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } | null } | null };

export type GetLeaseholdReviewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetLeaseholdReviewQuery = { __typename?: 'Query', leaseholdReview: { __typename?: 'LeaseholdReview', id: number, aiDocReview: { __typename?: 'AiDocReview', status: AiDocReviewStatus }, questions: Array<{ __typename?: 'LeaseholdQuestion', id: number, questionKey: LeaseholdQuestionKey, question: string, answer?: string | null, excerpt?: string | null, result: LeaseholdQuestionResult, clause?: string | null, page?: string | null }> } };

export type OfferQueryVariables = Exact<{
  offerId: Scalars['Int']['input'];
}>;


export type OfferQuery = { __typename?: 'Query', offer?: { __typename?: 'Offer', id: number, offerStatus: OfferStatus, propertyDescription: string, offerAmount: number, insufficientFundingExplanation?: string | null, coverLetter?: string | null, createdAt: any, purchase: { __typename?: 'Purchase', collectionKey: string, cashAmount: number, mortgageAdjustment?: { __typename?: 'MortgageAdjustment', id: number, fromValue: number, toValue: number } | null, propertySales: Array<{ __typename?: 'PropertySale', id: number, estimatedValue?: number | null }>, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number, description?: string | null }> } } | null };

export type GetProtectPolicyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProtectPolicyQuery = { __typename?: 'Query', protectPolicy?: { __typename?: 'ReservationAgreement', id: string, stage: ReservationAgreementStage, viewMode: ReservationAgreementViewMode, reason?: string | null, yourSide: TransactionSide, yourFullName?: string | null, yourResponse?: ResponseType | null, isYourPaymentMade: boolean, isYourKycComplete: boolean, theirSide: TransactionSide, theirFullName?: string | null, theirResponse?: ResponseType | null, isTheirPaymentMade: boolean, isTheirKycComplete: boolean, depositAmountInPounds: number, additionalConditions?: string | null, address?: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } | null, rejections?: Array<{ __typename?: 'ReservationAgreementRejection', id: number, name: string, reason?: string | null, createdAt: any }> | null } | null };

export type GetPurchaseQueryVariables = Exact<{
  collectionKey: Scalars['String']['input'];
}>;


export type GetPurchaseQuery = { __typename?: 'Query', purchase: { __typename?: 'Purchase', collectionKey: string, name: string, purchasePrice: number, purchaseStage?: PurchaseStage | null, cashAmount: number, purchaseCountry: PurchaseCountry, tenure: TenureType, isFirstPropertyPurchase: boolean, propertyOwnedCount: number, createdAt: any, updatedAt: any, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number, description?: string | null }>, propertySales: Array<{ __typename?: 'PropertySale', id: number, estimatedValue?: number | null }>, mortgageAdjustment?: { __typename?: 'MortgageAdjustment', id: number, fromValue: number, toValue: number } | null, mortgageInPrinciple?: { __typename?: 'Mip', id: string, status: TaskStatus } | null, conveyancing?: { __typename?: 'Conveyancing', status: TaskStatus } | null, files: Array<{ __typename?: 'File', id: string, name: string, url: string, mimeType: string }> } };

export type GetPurchasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchasesQuery = { __typename?: 'Query', purchases: Array<{ __typename?: 'Purchase', collectionKey: string, name: string, purchasePrice: number, purchaseStage?: PurchaseStage | null, cashAmount: number, purchaseCountry: PurchaseCountry, tenure: TenureType, isFirstPropertyPurchase: boolean, propertyOwnedCount: number, createdAt: any, updatedAt: any, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number, description?: string | null }>, propertySales: Array<{ __typename?: 'PropertySale', id: number, estimatedValue?: number | null }>, mortgageAdjustment?: { __typename?: 'MortgageAdjustment', id: number, fromValue: number, toValue: number } | null, mortgageInPrinciple?: { __typename?: 'Mip', id: string, status: TaskStatus } | null, conveyancing?: { __typename?: 'Conveyancing', status: TaskStatus } | null, files: Array<{ __typename?: 'File', id: string, name: string, url: string, mimeType: string }> }> };

export type GetSaleQueryVariables = Exact<{
  collectionKey: Scalars['String']['input'];
}>;


export type GetSaleQuery = { __typename?: 'Query', sale: { __typename?: 'Sale', collectionKey: string, estimatedPropertyValue?: number | null, tenure: TenureType, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, postcode: string, city: string }, listing?: { __typename?: 'Listing', id: number, price?: number | null, listingUrl?: string | null } | null, propertyPurchases: Array<{ __typename?: 'PropertyPurchase', id: number, estimatedValue?: number | null }> } };

export type GetSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesQuery = { __typename?: 'Query', sales: Array<{ __typename?: 'Sale', collectionKey: string, estimatedPropertyValue?: number | null, tenure: TenureType, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, postcode: string, city: string }, listing?: { __typename?: 'Listing', id: number, price?: number | null, listingUrl?: string | null } | null, propertyPurchases: Array<{ __typename?: 'PropertyPurchase', id: number, estimatedValue?: number | null }> }> };

type Item_ConveyancingRecommendations_Fragment = { __typename: 'ConveyancingRecommendations', itemId: string };

type Item_PersonalProtectPolicies_Fragment = { __typename: 'PersonalProtectPolicies', itemId: string };

type Item_ProtectInvitations_Fragment = { __typename: 'ProtectInvitations', itemId: string };

export type ItemFragment = Item_ConveyancingRecommendations_Fragment | Item_PersonalProtectPolicies_Fragment | Item_ProtectInvitations_Fragment;

export type KycApplicantDetailsFragment = { __typename?: 'Kyc', id: number, firstName: string, lastName: string, middleNames?: string | null, dob: any, address?: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } | null };

export type KycStatusFragment = { __typename?: 'Kyc', id: number, userIdentityCheck?: { __typename?: 'UserIdentityCheck', id: string, checkStatus: KycStatus, documentationReportStatus?: KycReportStatus | null, duplicateUserReportStatus?: KycReportStatus | null, facialMatchReportStatus?: KycReportStatus | null, watchlistReportStatus?: KycReportStatus | null } | null };

export type SubmitUserIdentityChecksMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitUserIdentityChecksMutation = { __typename?: 'Mutation', submitKycUserIdentityChecks: boolean };

export type UpdateLegalInfoMutationVariables = Exact<{
  legalInfo: UserLegalInfoInput;
}>;


export type UpdateLegalInfoMutation = { __typename?: 'Mutation', updateLegalInfo: boolean };

export type NegotiateReservationAgreementMutationVariables = Exact<{
  reservationAgreementId: Scalars['String']['input'];
  data: NegotiateReservationAgreementInput;
}>;


export type NegotiateReservationAgreementMutation = { __typename?: 'Mutation', isSuccessul: boolean };

export type PartnerBasicDetailsFragment = { __typename?: 'Partner', id: string, name: string, logoUrl: string };

export type ProtectPolicyFragment = { __typename?: 'ReservationAgreement', id: string, stage: ReservationAgreementStage, viewMode: ReservationAgreementViewMode, reason?: string | null, yourSide: TransactionSide, yourFullName?: string | null, yourResponse?: ResponseType | null, isYourPaymentMade: boolean, isYourKycComplete: boolean, theirSide: TransactionSide, theirFullName?: string | null, theirResponse?: ResponseType | null, isTheirPaymentMade: boolean, isTheirKycComplete: boolean, depositAmountInPounds: number, additionalConditions?: string | null, address?: { __typename?: 'Address', id: string, line1: string, line2?: string | null, line3?: string | null, city: string, postcode: string, singleLineAddress?: string | null } | null, rejections?: Array<{ __typename?: 'ReservationAgreementRejection', id: number, name: string, reason?: string | null, createdAt: any }> | null };

export type RecordLeaseholdReviewMistakeMutationVariables = Exact<{
  data: LeaseholdReviewReportMistakeInput;
}>;


export type RecordLeaseholdReviewMistakeMutation = { __typename?: 'Mutation', recordLeaseholdReviewMistake: boolean };

export type RemovePurchaseFundingMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  fundingId: Scalars['Float']['input'];
}>;


export type RemovePurchaseFundingMutation = { __typename?: 'Mutation', removePurchaseFunding: { __typename?: 'Purchase', collectionKey: string, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number }> } };

export type RemovePurchasePropertySaleMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  propertySaleId: Scalars['Float']['input'];
}>;


export type RemovePurchasePropertySaleMutation = { __typename?: 'Mutation', removePurchasePropertySale: { __typename?: 'Purchase', collectionKey: string, propertySales: Array<{ __typename?: 'PropertySale', id: number }> } };

export type RequestSignInMutationVariables = Exact<{
  email: Scalars['Email']['input'];
}>;


export type RequestSignInMutation = { __typename?: 'Mutation', requestSignIn: string };

export type RequestSignUpMutationVariables = Exact<{
  userDetails: CreateAccountInput;
}>;


export type RequestSignUpMutation = { __typename?: 'Mutation', requestSignUp: string };

export type RequestUpgradeAccountMutationVariables = Exact<{
  userDetails: UpgradeAccountInput;
}>;


export type RequestUpgradeAccountMutation = { __typename?: 'Mutation', upgradeToFullAccount: { __typename?: 'PersonalProfile', id: number, preferredName?: string | null } };

export type SubmitClaimMutationVariables = Exact<{
  reservationAgreementId: Scalars['String']['input'];
  claim: ClaimInput;
}>;


export type SubmitClaimMutation = { __typename?: 'Mutation', isSubmitted: boolean };

export type SubmitOfferMutationVariables = Exact<{
  offer: CreateOfferInput;
}>;


export type SubmitOfferMutation = { __typename?: 'Mutation', createOffer: { __typename?: 'Offer', id: number } };

export type BookSurveyMutationVariables = Exact<{
  data: SurveyInput;
}>;


export type BookSurveyMutation = { __typename?: 'Mutation', bookSurvey: { __typename?: 'Survey', id: string, type: SurveyType, status: RequestStatus } };

export type UpdateMortgageAdjustmentMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  data: UpdateMortgageAdjustmentInput;
}>;


export type UpdateMortgageAdjustmentMutation = { __typename?: 'Mutation', updateMortgageAdjustment: { __typename?: 'Purchase', collectionKey: string, mortgageAdjustment?: { __typename?: 'MortgageAdjustment', fromValue: number, toValue: number } | null } };

export type UpdatePurchaseMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  updatedPurchase: UpdatePurchaseInput;
}>;


export type UpdatePurchaseMutation = { __typename?: 'Mutation', updatePurchase: { __typename?: 'Purchase', collectionKey: string, name: string, purchasePrice: number, purchaseCountry: PurchaseCountry, tenure: TenureType, cashAmount: number, isFirstPropertyPurchase: boolean } };

export type UpdatePurchaseFundingMutationVariables = Exact<{
  collectionKey: Scalars['String']['input'];
  fundingId: Scalars['Float']['input'];
  funding: UpdateFundingInput;
}>;


export type UpdatePurchaseFundingMutation = { __typename?: 'Mutation', updatePurchaseFunding: { __typename?: 'Purchase', collectionKey: string, otherFunding: Array<{ __typename?: 'Funding', id: number, source: FundingSourceType, totalValue: number }> } };

export type UploadLeaseholdReviewMutationVariables = Exact<{
  data: LeaseholdReviewInput;
}>;


export type UploadLeaseholdReviewMutation = { __typename?: 'Mutation', leasholdReview: { __typename?: 'LeaseholdReview', id: number } };

export type VerifyEmailMutationVariables = Exact<{
  verifyEmail: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', requestVerifyEmailLink: boolean };

export const ConveyancingBusinessBasicInfoFragmentDoc = gql`
    fragment ConveyancingBusinessBasicInfo on ConveyancingBusiness {
  id
  name
  logoUrl
  website
  description
  isAcceptingClients
  outcode
  address
  googlePlacesId
  regulation
  regulationNumber
  protectionRating
  trustpilot {
    id
    stars
    reviews
  }
}
    `;
export const ConveyancingPlanFragmentDoc = gql`
    fragment ConveyancingPlan on Plan {
  id
  name
  logoUrl
  description
  percentageFromAverage
  priceRating
  cashback
}
    `;
export const RequisitionSummaryFragmentDoc = gql`
    fragment RequisitionSummary on RequisitionSummary {
  inaccuracyRating
  inaccuracyPercentage
  totalSubmissionCount
  totalRequisitionRequests
}
    `;
export const ConveyancingRequestFragmentDoc = gql`
    fragment ConveyancingRequest on Request {
  id
  type
  status
}
    `;
export const ConveyancingEstimateFragmentDoc = gql`
    fragment ConveyancingEstimate on ConveyancingEstimate {
  recommendationId
  conveyancerId
  isArchived
  cost
  conveyancer {
    ...ConveyancingBusinessBasicInfo
    standardPlan {
      ...ConveyancingPlan
    }
    premiumPlan {
      ...ConveyancingPlan
    }
    requisitionSummary {
      ...RequisitionSummary
    }
  }
  requests {
    ...ConveyancingRequest
  }
}
    ${ConveyancingBusinessBasicInfoFragmentDoc}
${ConveyancingPlanFragmentDoc}
${RequisitionSummaryFragmentDoc}
${ConveyancingRequestFragmentDoc}`;
export const BasicAddressFragmentDoc = gql`
    fragment BasicAddress on Address {
  id
  line1
  line2
  line3
  city
  postcode
  singleLineAddress
}
    `;
export const ConveyancingRecommendationFragmentDoc = gql`
    fragment ConveyancingRecommendation on ConveyancingRecommendation {
  id
  situation
  urgency
  priority
  estimatedAverageCost
  estimates {
    ...ConveyancingEstimate
  }
  purchaseDetails {
    requestId
    price
    mortgage
    buyerCount
    tenure
    areaOutcode
    additionalDetails
  }
  saleDetails {
    requestId
    price
    sellerCount
    hasMortgage
    address {
      ...BasicAddress
    }
    additionalDetails
  }
}
    ${ConveyancingEstimateFragmentDoc}
${BasicAddressFragmentDoc}`;
export const FullPurchaseFragmentDoc = gql`
    fragment FullPurchase on Purchase {
  collectionKey
  name
  purchasePrice
  purchaseStage
  cashAmount
  purchaseCountry
  tenure
  isFirstPropertyPurchase
  propertyOwnedCount
  otherFunding {
    id
    source
    totalValue
    description
  }
  propertySales {
    id
    estimatedValue
  }
  mortgageAdjustment {
    id
    fromValue
    toValue
  }
  mortgageInPrinciple {
    id
    status
  }
  conveyancing {
    status
  }
  files {
    id
    name
    url
    mimeType
  }
  createdAt
  updatedAt
}
    `;
export const FullSaleFragmentDoc = gql`
    fragment FullSale on Sale {
  collectionKey
  estimatedPropertyValue
  tenure
  address {
    line1
    line2
    line3
    postcode
    city
  }
  listing {
    id
    price
    listingUrl
  }
  propertyPurchases {
    id
    estimatedValue
  }
}
    `;
export const ItemFragmentDoc = gql`
    fragment Item on ItemUnion {
  __typename
  ... on PersonalProtectPolicies {
    itemId
  }
  ... on ProtectInvitations {
    itemId
  }
  ... on ConveyancingRecommendations {
    itemId
  }
}
    `;
export const KycApplicantDetailsFragmentDoc = gql`
    fragment KycApplicantDetails on Kyc {
  id
  firstName
  lastName
  middleNames
  dob
  address {
    ...BasicAddress
  }
}
    ${BasicAddressFragmentDoc}`;
export const KycStatusFragmentDoc = gql`
    fragment KycStatus on Kyc {
  id
  userIdentityCheck {
    id
    checkStatus
    documentationReportStatus
    duplicateUserReportStatus
    facialMatchReportStatus
    watchlistReportStatus
  }
}
    `;
export const PartnerBasicDetailsFragmentDoc = gql`
    fragment PartnerBasicDetails on Partner {
  id
  name
  logoUrl
}
    `;
export const ProtectPolicyFragmentDoc = gql`
    fragment ProtectPolicy on ReservationAgreement {
  id
  stage
  viewMode
  reason
  yourSide
  yourFullName
  yourResponse
  isYourPaymentMade
  isYourKycComplete
  theirSide
  theirFullName
  theirResponse
  isTheirPaymentMade
  isTheirKycComplete
  address {
    ...BasicAddress
  }
  rejections {
    id
    name
    reason
    createdAt
  }
  depositAmountInPounds
  additionalConditions
}
    ${BasicAddressFragmentDoc}`;
export const AcceptOfferDocument = gql`
    mutation AcceptOffer($offerId: Int!) {
  acceptOffer(offerId: $offerId)
}
    `;
export type AcceptOfferMutationFn = Apollo.MutationFunction<AcceptOfferMutation, AcceptOfferMutationVariables>;

/**
 * __useAcceptOfferMutation__
 *
 * To run a mutation, you first call `useAcceptOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOfferMutation, { data, loading, error }] = useAcceptOfferMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useAcceptOfferMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOfferMutation, AcceptOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOfferMutation, AcceptOfferMutationVariables>(AcceptOfferDocument, options);
      }
export type AcceptOfferMutationHookResult = ReturnType<typeof useAcceptOfferMutation>;
export type AcceptOfferMutationResult = Apollo.MutationResult<AcceptOfferMutation>;
export type AcceptOfferMutationOptions = Apollo.BaseMutationOptions<AcceptOfferMutation, AcceptOfferMutationVariables>;
export const AcceptReservationAgreementDocument = gql`
    mutation AcceptReservationAgreement($reservationAgreementId: String!, $data: AcceptReservationAgreementInput!) {
  isSuccessul: acceptReservationAgreement(
    reservationAgreementId: $reservationAgreementId
    data: $data
  )
}
    `;
export type AcceptReservationAgreementMutationFn = Apollo.MutationFunction<AcceptReservationAgreementMutation, AcceptReservationAgreementMutationVariables>;

/**
 * __useAcceptReservationAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptReservationAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReservationAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReservationAgreementMutation, { data, loading, error }] = useAcceptReservationAgreementMutation({
 *   variables: {
 *      reservationAgreementId: // value for 'reservationAgreementId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAcceptReservationAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptReservationAgreementMutation, AcceptReservationAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptReservationAgreementMutation, AcceptReservationAgreementMutationVariables>(AcceptReservationAgreementDocument, options);
      }
export type AcceptReservationAgreementMutationHookResult = ReturnType<typeof useAcceptReservationAgreementMutation>;
export type AcceptReservationAgreementMutationResult = Apollo.MutationResult<AcceptReservationAgreementMutation>;
export type AcceptReservationAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptReservationAgreementMutation, AcceptReservationAgreementMutationVariables>;
export const AddFundingToPurchaseDocument = gql`
    mutation AddFundingToPurchase($collectionKey: String!, $funding: CreateFundingInput!) {
  addFundingToPurchase(collectionKey: $collectionKey, funding: $funding) {
    collectionKey
    otherFunding {
      id
      source
      totalValue
    }
    createdAt
    updatedAt
  }
}
    `;
export type AddFundingToPurchaseMutationFn = Apollo.MutationFunction<AddFundingToPurchaseMutation, AddFundingToPurchaseMutationVariables>;

/**
 * __useAddFundingToPurchaseMutation__
 *
 * To run a mutation, you first call `useAddFundingToPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFundingToPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFundingToPurchaseMutation, { data, loading, error }] = useAddFundingToPurchaseMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      funding: // value for 'funding'
 *   },
 * });
 */
export function useAddFundingToPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<AddFundingToPurchaseMutation, AddFundingToPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFundingToPurchaseMutation, AddFundingToPurchaseMutationVariables>(AddFundingToPurchaseDocument, options);
      }
export type AddFundingToPurchaseMutationHookResult = ReturnType<typeof useAddFundingToPurchaseMutation>;
export type AddFundingToPurchaseMutationResult = Apollo.MutationResult<AddFundingToPurchaseMutation>;
export type AddFundingToPurchaseMutationOptions = Apollo.BaseMutationOptions<AddFundingToPurchaseMutation, AddFundingToPurchaseMutationVariables>;
export const AddPropertySaleToPurchaseDocument = gql`
    mutation AddPropertySaleToPurchase($collectionKey: String!, $propertySale: CreatePropertySaleInput!) {
  addPropertySaleToPurchase(
    collectionKey: $collectionKey
    propertySale: $propertySale
  ) {
    collectionKey
    propertySales {
      id
      estimatedValue
    }
  }
}
    `;
export type AddPropertySaleToPurchaseMutationFn = Apollo.MutationFunction<AddPropertySaleToPurchaseMutation, AddPropertySaleToPurchaseMutationVariables>;

/**
 * __useAddPropertySaleToPurchaseMutation__
 *
 * To run a mutation, you first call `useAddPropertySaleToPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertySaleToPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertySaleToPurchaseMutation, { data, loading, error }] = useAddPropertySaleToPurchaseMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      propertySale: // value for 'propertySale'
 *   },
 * });
 */
export function useAddPropertySaleToPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertySaleToPurchaseMutation, AddPropertySaleToPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertySaleToPurchaseMutation, AddPropertySaleToPurchaseMutationVariables>(AddPropertySaleToPurchaseDocument, options);
      }
export type AddPropertySaleToPurchaseMutationHookResult = ReturnType<typeof useAddPropertySaleToPurchaseMutation>;
export type AddPropertySaleToPurchaseMutationResult = Apollo.MutationResult<AddPropertySaleToPurchaseMutation>;
export type AddPropertySaleToPurchaseMutationOptions = Apollo.BaseMutationOptions<AddPropertySaleToPurchaseMutation, AddPropertySaleToPurchaseMutationVariables>;
export const AuthStatusDocument = gql`
    query AuthStatus {
  authStatus
}
    `;

/**
 * __useAuthStatusQuery__
 *
 * To run a query within a React component, call `useAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<AuthStatusQuery, AuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthStatusQuery, AuthStatusQueryVariables>(AuthStatusDocument, options);
      }
export function useAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthStatusQuery, AuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthStatusQuery, AuthStatusQueryVariables>(AuthStatusDocument, options);
        }
export type AuthStatusQueryHookResult = ReturnType<typeof useAuthStatusQuery>;
export type AuthStatusLazyQueryHookResult = ReturnType<typeof useAuthStatusLazyQuery>;
export type AuthStatusQueryResult = Apollo.QueryResult<AuthStatusQuery, AuthStatusQueryVariables>;
export const ConfirmAcceptanceOfReservationAgreementDocument = gql`
    mutation ConfirmAcceptanceOfReservationAgreement($reservationAgreementId: String!) {
  isSuccessful: confirmAcceptanceOfReservationAgreement(
    reservationAgreementId: $reservationAgreementId
  )
}
    `;
export type ConfirmAcceptanceOfReservationAgreementMutationFn = Apollo.MutationFunction<ConfirmAcceptanceOfReservationAgreementMutation, ConfirmAcceptanceOfReservationAgreementMutationVariables>;

/**
 * __useConfirmAcceptanceOfReservationAgreementMutation__
 *
 * To run a mutation, you first call `useConfirmAcceptanceOfReservationAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAcceptanceOfReservationAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAcceptanceOfReservationAgreementMutation, { data, loading, error }] = useConfirmAcceptanceOfReservationAgreementMutation({
 *   variables: {
 *      reservationAgreementId: // value for 'reservationAgreementId'
 *   },
 * });
 */
export function useConfirmAcceptanceOfReservationAgreementMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAcceptanceOfReservationAgreementMutation, ConfirmAcceptanceOfReservationAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAcceptanceOfReservationAgreementMutation, ConfirmAcceptanceOfReservationAgreementMutationVariables>(ConfirmAcceptanceOfReservationAgreementDocument, options);
      }
export type ConfirmAcceptanceOfReservationAgreementMutationHookResult = ReturnType<typeof useConfirmAcceptanceOfReservationAgreementMutation>;
export type ConfirmAcceptanceOfReservationAgreementMutationResult = Apollo.MutationResult<ConfirmAcceptanceOfReservationAgreementMutation>;
export type ConfirmAcceptanceOfReservationAgreementMutationOptions = Apollo.BaseMutationOptions<ConfirmAcceptanceOfReservationAgreementMutation, ConfirmAcceptanceOfReservationAgreementMutationVariables>;
export const ConfirmReservationAgreementPaymentDocument = gql`
    mutation ConfirmReservationAgreementPayment($id: String!) {
  isConfirmed: confirmReservationAgreementPaymentMade(reservationAgreementId: $id)
}
    `;
export type ConfirmReservationAgreementPaymentMutationFn = Apollo.MutationFunction<ConfirmReservationAgreementPaymentMutation, ConfirmReservationAgreementPaymentMutationVariables>;

/**
 * __useConfirmReservationAgreementPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmReservationAgreementPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmReservationAgreementPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmReservationAgreementPaymentMutation, { data, loading, error }] = useConfirmReservationAgreementPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmReservationAgreementPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmReservationAgreementPaymentMutation, ConfirmReservationAgreementPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmReservationAgreementPaymentMutation, ConfirmReservationAgreementPaymentMutationVariables>(ConfirmReservationAgreementPaymentDocument, options);
      }
export type ConfirmReservationAgreementPaymentMutationHookResult = ReturnType<typeof useConfirmReservationAgreementPaymentMutation>;
export type ConfirmReservationAgreementPaymentMutationResult = Apollo.MutationResult<ConfirmReservationAgreementPaymentMutation>;
export type ConfirmReservationAgreementPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmReservationAgreementPaymentMutation, ConfirmReservationAgreementPaymentMutationVariables>;
export const CreateConveyancingRecommendationDocument = gql`
    mutation CreateConveyancingRecommendation($data: CreateConveyancingRecommendationInput!) {
  conveyancingRecommendation: createConveyancingRecommendation(data: $data) {
    ...ConveyancingRecommendation
  }
}
    ${ConveyancingRecommendationFragmentDoc}`;
export type CreateConveyancingRecommendationMutationFn = Apollo.MutationFunction<CreateConveyancingRecommendationMutation, CreateConveyancingRecommendationMutationVariables>;

/**
 * __useCreateConveyancingRecommendationMutation__
 *
 * To run a mutation, you first call `useCreateConveyancingRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConveyancingRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConveyancingRecommendationMutation, { data, loading, error }] = useCreateConveyancingRecommendationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateConveyancingRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConveyancingRecommendationMutation, CreateConveyancingRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConveyancingRecommendationMutation, CreateConveyancingRecommendationMutationVariables>(CreateConveyancingRecommendationDocument, options);
      }
export type CreateConveyancingRecommendationMutationHookResult = ReturnType<typeof useCreateConveyancingRecommendationMutation>;
export type CreateConveyancingRecommendationMutationResult = Apollo.MutationResult<CreateConveyancingRecommendationMutation>;
export type CreateConveyancingRecommendationMutationOptions = Apollo.BaseMutationOptions<CreateConveyancingRecommendationMutation, CreateConveyancingRecommendationMutationVariables>;
export const ConveyancingRecommendationDocument = gql`
    query ConveyancingRecommendation($id: String!) {
  conveyancingRecommendation(id: $id) {
    ...ConveyancingRecommendation
  }
}
    ${ConveyancingRecommendationFragmentDoc}`;

/**
 * __useConveyancingRecommendationQuery__
 *
 * To run a query within a React component, call `useConveyancingRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConveyancingRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConveyancingRecommendationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConveyancingRecommendationQuery(baseOptions: Apollo.QueryHookOptions<ConveyancingRecommendationQuery, ConveyancingRecommendationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConveyancingRecommendationQuery, ConveyancingRecommendationQueryVariables>(ConveyancingRecommendationDocument, options);
      }
export function useConveyancingRecommendationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConveyancingRecommendationQuery, ConveyancingRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConveyancingRecommendationQuery, ConveyancingRecommendationQueryVariables>(ConveyancingRecommendationDocument, options);
        }
export type ConveyancingRecommendationQueryHookResult = ReturnType<typeof useConveyancingRecommendationQuery>;
export type ConveyancingRecommendationLazyQueryHookResult = ReturnType<typeof useConveyancingRecommendationLazyQuery>;
export type ConveyancingRecommendationQueryResult = Apollo.QueryResult<ConveyancingRecommendationQuery, ConveyancingRecommendationQueryVariables>;
export const MakeConveyancingRequestDocument = gql`
    mutation MakeConveyancingRequest($recommendationId: String!, $conveyancerId: String!, $request: MakeRequestInput!) {
  makeConveyancingRequest(
    recommendationId: $recommendationId
    conveyancerId: $conveyancerId
    request: $request
  ) {
    recommendationId
    conveyancerId
    requests {
      id
      type
      status
    }
  }
}
    `;
export type MakeConveyancingRequestMutationFn = Apollo.MutationFunction<MakeConveyancingRequestMutation, MakeConveyancingRequestMutationVariables>;

/**
 * __useMakeConveyancingRequestMutation__
 *
 * To run a mutation, you first call `useMakeConveyancingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeConveyancingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeConveyancingRequestMutation, { data, loading, error }] = useMakeConveyancingRequestMutation({
 *   variables: {
 *      recommendationId: // value for 'recommendationId'
 *      conveyancerId: // value for 'conveyancerId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useMakeConveyancingRequestMutation(baseOptions?: Apollo.MutationHookOptions<MakeConveyancingRequestMutation, MakeConveyancingRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeConveyancingRequestMutation, MakeConveyancingRequestMutationVariables>(MakeConveyancingRequestDocument, options);
      }
export type MakeConveyancingRequestMutationHookResult = ReturnType<typeof useMakeConveyancingRequestMutation>;
export type MakeConveyancingRequestMutationResult = Apollo.MutationResult<MakeConveyancingRequestMutation>;
export type MakeConveyancingRequestMutationOptions = Apollo.BaseMutationOptions<MakeConveyancingRequestMutation, MakeConveyancingRequestMutationVariables>;
export const CreateDraftProtectPolicyDocument = gql`
    mutation CreateDraftProtectPolicy($data: ReservationAgreementInput!) {
  draftPolicy: createDraftReservationAgreement(data: $data) {
    ...ProtectPolicy
  }
}
    ${ProtectPolicyFragmentDoc}`;
export type CreateDraftProtectPolicyMutationFn = Apollo.MutationFunction<CreateDraftProtectPolicyMutation, CreateDraftProtectPolicyMutationVariables>;

/**
 * __useCreateDraftProtectPolicyMutation__
 *
 * To run a mutation, you first call `useCreateDraftProtectPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftProtectPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftProtectPolicyMutation, { data, loading, error }] = useCreateDraftProtectPolicyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDraftProtectPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftProtectPolicyMutation, CreateDraftProtectPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftProtectPolicyMutation, CreateDraftProtectPolicyMutationVariables>(CreateDraftProtectPolicyDocument, options);
      }
export type CreateDraftProtectPolicyMutationHookResult = ReturnType<typeof useCreateDraftProtectPolicyMutation>;
export type CreateDraftProtectPolicyMutationResult = Apollo.MutationResult<CreateDraftProtectPolicyMutation>;
export type CreateDraftProtectPolicyMutationOptions = Apollo.BaseMutationOptions<CreateDraftProtectPolicyMutation, CreateDraftProtectPolicyMutationVariables>;
export const CreateExternalMipDocument = gql`
    mutation CreateExternalMip($collectionKey: String!) {
  createExternalMip(collectionKey: $collectionKey) {
    id
  }
}
    `;
export type CreateExternalMipMutationFn = Apollo.MutationFunction<CreateExternalMipMutation, CreateExternalMipMutationVariables>;

/**
 * __useCreateExternalMipMutation__
 *
 * To run a mutation, you first call `useCreateExternalMipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalMipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalMipMutation, { data, loading, error }] = useCreateExternalMipMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *   },
 * });
 */
export function useCreateExternalMipMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalMipMutation, CreateExternalMipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalMipMutation, CreateExternalMipMutationVariables>(CreateExternalMipDocument, options);
      }
export type CreateExternalMipMutationHookResult = ReturnType<typeof useCreateExternalMipMutation>;
export type CreateExternalMipMutationResult = Apollo.MutationResult<CreateExternalMipMutation>;
export type CreateExternalMipMutationOptions = Apollo.BaseMutationOptions<CreateExternalMipMutation, CreateExternalMipMutationVariables>;
export const CreateKycSessionDocument = gql`
    mutation CreateKycSession {
  createKycSession {
    token
    expiration
  }
}
    `;
export type CreateKycSessionMutationFn = Apollo.MutationFunction<CreateKycSessionMutation, CreateKycSessionMutationVariables>;

/**
 * __useCreateKycSessionMutation__
 *
 * To run a mutation, you first call `useCreateKycSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKycSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKycSessionMutation, { data, loading, error }] = useCreateKycSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateKycSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateKycSessionMutation, CreateKycSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKycSessionMutation, CreateKycSessionMutationVariables>(CreateKycSessionDocument, options);
      }
export type CreateKycSessionMutationHookResult = ReturnType<typeof useCreateKycSessionMutation>;
export type CreateKycSessionMutationResult = Apollo.MutationResult<CreateKycSessionMutation>;
export type CreateKycSessionMutationOptions = Apollo.BaseMutationOptions<CreateKycSessionMutation, CreateKycSessionMutationVariables>;
export const CreateMiPDocument = gql`
    mutation CreateMiP($collectionKey: String!) {
  createMip(collectionKey: $collectionKey) {
    id
  }
}
    `;
export type CreateMiPMutationFn = Apollo.MutationFunction<CreateMiPMutation, CreateMiPMutationVariables>;

/**
 * __useCreateMiPMutation__
 *
 * To run a mutation, you first call `useCreateMiPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMiPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMiPMutation, { data, loading, error }] = useCreateMiPMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *   },
 * });
 */
export function useCreateMiPMutation(baseOptions?: Apollo.MutationHookOptions<CreateMiPMutation, CreateMiPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMiPMutation, CreateMiPMutationVariables>(CreateMiPDocument, options);
      }
export type CreateMiPMutationHookResult = ReturnType<typeof useCreateMiPMutation>;
export type CreateMiPMutationResult = Apollo.MutationResult<CreateMiPMutation>;
export type CreateMiPMutationOptions = Apollo.BaseMutationOptions<CreateMiPMutation, CreateMiPMutationVariables>;
export const CreatePurchaseDocument = gql`
    mutation CreatePurchase($purchase: CreatePurchaseInput!) {
  createPurchase(purchase: $purchase) {
    ...FullPurchase
  }
}
    ${FullPurchaseFragmentDoc}`;
export type CreatePurchaseMutationFn = Apollo.MutationFunction<CreatePurchaseMutation, CreatePurchaseMutationVariables>;

/**
 * __useCreatePurchaseMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseMutation, { data, loading, error }] = useCreatePurchaseMutation({
 *   variables: {
 *      purchase: // value for 'purchase'
 *   },
 * });
 */
export function useCreatePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseMutation, CreatePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseMutation, CreatePurchaseMutationVariables>(CreatePurchaseDocument, options);
      }
export type CreatePurchaseMutationHookResult = ReturnType<typeof useCreatePurchaseMutation>;
export type CreatePurchaseMutationResult = Apollo.MutationResult<CreatePurchaseMutation>;
export type CreatePurchaseMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseMutation, CreatePurchaseMutationVariables>;
export const CreateSaleDocument = gql`
    mutation CreateSale($sale: CreateSaleInput!) {
  createSale(sale: $sale) {
    ...FullSale
  }
}
    ${FullSaleFragmentDoc}`;
export type CreateSaleMutationFn = Apollo.MutationFunction<CreateSaleMutation, CreateSaleMutationVariables>;

/**
 * __useCreateSaleMutation__
 *
 * To run a mutation, you first call `useCreateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleMutation, { data, loading, error }] = useCreateSaleMutation({
 *   variables: {
 *      sale: // value for 'sale'
 *   },
 * });
 */
export function useCreateSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleMutation, CreateSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleMutation, CreateSaleMutationVariables>(CreateSaleDocument, options);
      }
export type CreateSaleMutationHookResult = ReturnType<typeof useCreateSaleMutation>;
export type CreateSaleMutationResult = Apollo.MutationResult<CreateSaleMutation>;
export type CreateSaleMutationOptions = Apollo.BaseMutationOptions<CreateSaleMutation, CreateSaleMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  authStatus
  currentProfile {
    ...PartnerBasicDetails
  }
  self {
    id
    email
    firstName
    lastName
    phone
    preferredName
    kyc {
      id
    }
    purchases {
      collectionKey
      name
    }
    sales {
      collectionKey
      name
    }
    businesses {
      ...PartnerBasicDetails
    }
    referralCode
    referralCount
    referralEarned
    referralPaid
  }
  items {
    ...Item
  }
}
    ${PartnerBasicDetailsFragmentDoc}
${ItemFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const DeclineOfferDocument = gql`
    mutation DeclineOffer($offerId: Int!) {
  declineOffer(offerId: $offerId)
}
    `;
export type DeclineOfferMutationFn = Apollo.MutationFunction<DeclineOfferMutation, DeclineOfferMutationVariables>;

/**
 * __useDeclineOfferMutation__
 *
 * To run a mutation, you first call `useDeclineOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineOfferMutation, { data, loading, error }] = useDeclineOfferMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useDeclineOfferMutation(baseOptions?: Apollo.MutationHookOptions<DeclineOfferMutation, DeclineOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineOfferMutation, DeclineOfferMutationVariables>(DeclineOfferDocument, options);
      }
export type DeclineOfferMutationHookResult = ReturnType<typeof useDeclineOfferMutation>;
export type DeclineOfferMutationResult = Apollo.MutationResult<DeclineOfferMutation>;
export type DeclineOfferMutationOptions = Apollo.BaseMutationOptions<DeclineOfferMutation, DeclineOfferMutationVariables>;
export const DeclineReservationAgreementDocument = gql`
    mutation DeclineReservationAgreement($reservationAgreementId: String!, $data: DeclineReservationAgreementInput!) {
  isDeclined: declineReservationAgreement(
    reservationAgreementId: $reservationAgreementId
    data: $data
  )
}
    `;
export type DeclineReservationAgreementMutationFn = Apollo.MutationFunction<DeclineReservationAgreementMutation, DeclineReservationAgreementMutationVariables>;

/**
 * __useDeclineReservationAgreementMutation__
 *
 * To run a mutation, you first call `useDeclineReservationAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineReservationAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineReservationAgreementMutation, { data, loading, error }] = useDeclineReservationAgreementMutation({
 *   variables: {
 *      reservationAgreementId: // value for 'reservationAgreementId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeclineReservationAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeclineReservationAgreementMutation, DeclineReservationAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineReservationAgreementMutation, DeclineReservationAgreementMutationVariables>(DeclineReservationAgreementDocument, options);
      }
export type DeclineReservationAgreementMutationHookResult = ReturnType<typeof useDeclineReservationAgreementMutation>;
export type DeclineReservationAgreementMutationResult = Apollo.MutationResult<DeclineReservationAgreementMutation>;
export type DeclineReservationAgreementMutationOptions = Apollo.BaseMutationOptions<DeclineReservationAgreementMutation, DeclineReservationAgreementMutationVariables>;
export const DismissReservationAgreementRejectionDocument = gql`
    mutation DismissReservationAgreementRejection($id: Float!) {
  isDismissed: dismissReservationAgreementRejection(rejectionId: $id)
}
    `;
export type DismissReservationAgreementRejectionMutationFn = Apollo.MutationFunction<DismissReservationAgreementRejectionMutation, DismissReservationAgreementRejectionMutationVariables>;

/**
 * __useDismissReservationAgreementRejectionMutation__
 *
 * To run a mutation, you first call `useDismissReservationAgreementRejectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissReservationAgreementRejectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissReservationAgreementRejectionMutation, { data, loading, error }] = useDismissReservationAgreementRejectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissReservationAgreementRejectionMutation(baseOptions?: Apollo.MutationHookOptions<DismissReservationAgreementRejectionMutation, DismissReservationAgreementRejectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissReservationAgreementRejectionMutation, DismissReservationAgreementRejectionMutationVariables>(DismissReservationAgreementRejectionDocument, options);
      }
export type DismissReservationAgreementRejectionMutationHookResult = ReturnType<typeof useDismissReservationAgreementRejectionMutation>;
export type DismissReservationAgreementRejectionMutationResult = Apollo.MutationResult<DismissReservationAgreementRejectionMutation>;
export type DismissReservationAgreementRejectionMutationOptions = Apollo.BaseMutationOptions<DismissReservationAgreementRejectionMutation, DismissReservationAgreementRejectionMutationVariables>;
export const GetAddressDocument = gql`
    query GetAddress($id: String!) {
  address(id: $id) {
    ...BasicAddress
  }
}
    ${BasicAddressFragmentDoc}`;

/**
 * __useGetAddressQuery__
 *
 * To run a query within a React component, call `useGetAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddressQuery(baseOptions: Apollo.QueryHookOptions<GetAddressQuery, GetAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressQuery, GetAddressQueryVariables>(GetAddressDocument, options);
      }
export function useGetAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressQuery, GetAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressQuery, GetAddressQueryVariables>(GetAddressDocument, options);
        }
export type GetAddressQueryHookResult = ReturnType<typeof useGetAddressQuery>;
export type GetAddressLazyQueryHookResult = ReturnType<typeof useGetAddressLazyQuery>;
export type GetAddressQueryResult = Apollo.QueryResult<GetAddressQuery, GetAddressQueryVariables>;
export const GetKycUserIdentityCheckStatusDocument = gql`
    query GetKycUserIdentityCheckStatus {
  kyc {
    ...KycStatus
    ...KycApplicantDetails
  }
}
    ${KycStatusFragmentDoc}
${KycApplicantDetailsFragmentDoc}`;

/**
 * __useGetKycUserIdentityCheckStatusQuery__
 *
 * To run a query within a React component, call `useGetKycUserIdentityCheckStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKycUserIdentityCheckStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKycUserIdentityCheckStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKycUserIdentityCheckStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetKycUserIdentityCheckStatusQuery, GetKycUserIdentityCheckStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKycUserIdentityCheckStatusQuery, GetKycUserIdentityCheckStatusQueryVariables>(GetKycUserIdentityCheckStatusDocument, options);
      }
export function useGetKycUserIdentityCheckStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKycUserIdentityCheckStatusQuery, GetKycUserIdentityCheckStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKycUserIdentityCheckStatusQuery, GetKycUserIdentityCheckStatusQueryVariables>(GetKycUserIdentityCheckStatusDocument, options);
        }
export type GetKycUserIdentityCheckStatusQueryHookResult = ReturnType<typeof useGetKycUserIdentityCheckStatusQuery>;
export type GetKycUserIdentityCheckStatusLazyQueryHookResult = ReturnType<typeof useGetKycUserIdentityCheckStatusLazyQuery>;
export type GetKycUserIdentityCheckStatusQueryResult = Apollo.QueryResult<GetKycUserIdentityCheckStatusQuery, GetKycUserIdentityCheckStatusQueryVariables>;
export const GetLeaseholdReviewDocument = gql`
    query GetLeaseholdReview($id: Int!) {
  leaseholdReview(id: $id) {
    id
    aiDocReview {
      status
    }
    questions {
      id
      questionKey
      question
      answer
      excerpt
      result
      clause
      page
    }
  }
}
    `;

/**
 * __useGetLeaseholdReviewQuery__
 *
 * To run a query within a React component, call `useGetLeaseholdReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseholdReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseholdReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeaseholdReviewQuery(baseOptions: Apollo.QueryHookOptions<GetLeaseholdReviewQuery, GetLeaseholdReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseholdReviewQuery, GetLeaseholdReviewQueryVariables>(GetLeaseholdReviewDocument, options);
      }
export function useGetLeaseholdReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseholdReviewQuery, GetLeaseholdReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseholdReviewQuery, GetLeaseholdReviewQueryVariables>(GetLeaseholdReviewDocument, options);
        }
export type GetLeaseholdReviewQueryHookResult = ReturnType<typeof useGetLeaseholdReviewQuery>;
export type GetLeaseholdReviewLazyQueryHookResult = ReturnType<typeof useGetLeaseholdReviewLazyQuery>;
export type GetLeaseholdReviewQueryResult = Apollo.QueryResult<GetLeaseholdReviewQuery, GetLeaseholdReviewQueryVariables>;
export const OfferDocument = gql`
    query Offer($offerId: Int!) {
  offer(id: $offerId) {
    id
    offerStatus
    propertyDescription
    offerAmount
    insufficientFundingExplanation
    coverLetter
    purchase {
      collectionKey
      mortgageAdjustment {
        id
        fromValue
        toValue
      }
      propertySales {
        id
        estimatedValue
      }
      otherFunding {
        id
        source
        totalValue
        description
      }
      cashAmount
    }
    createdAt
  }
}
    `;

/**
 * __useOfferQuery__
 *
 * To run a query within a React component, call `useOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useOfferQuery(baseOptions: Apollo.QueryHookOptions<OfferQuery, OfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
      }
export function useOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferQuery, OfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
        }
export type OfferQueryHookResult = ReturnType<typeof useOfferQuery>;
export type OfferLazyQueryHookResult = ReturnType<typeof useOfferLazyQuery>;
export type OfferQueryResult = Apollo.QueryResult<OfferQuery, OfferQueryVariables>;
export const GetProtectPolicyDocument = gql`
    query GetProtectPolicy($id: String!) {
  protectPolicy: getReservationAgreement(id: $id) {
    ...ProtectPolicy
  }
}
    ${ProtectPolicyFragmentDoc}`;

/**
 * __useGetProtectPolicyQuery__
 *
 * To run a query within a React component, call `useGetProtectPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProtectPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetProtectPolicyQuery, GetProtectPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectPolicyQuery, GetProtectPolicyQueryVariables>(GetProtectPolicyDocument, options);
      }
export function useGetProtectPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectPolicyQuery, GetProtectPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectPolicyQuery, GetProtectPolicyQueryVariables>(GetProtectPolicyDocument, options);
        }
export type GetProtectPolicyQueryHookResult = ReturnType<typeof useGetProtectPolicyQuery>;
export type GetProtectPolicyLazyQueryHookResult = ReturnType<typeof useGetProtectPolicyLazyQuery>;
export type GetProtectPolicyQueryResult = Apollo.QueryResult<GetProtectPolicyQuery, GetProtectPolicyQueryVariables>;
export const GetPurchaseDocument = gql`
    query GetPurchase($collectionKey: String!) {
  purchase(collectionKey: $collectionKey) {
    ...FullPurchase
  }
}
    ${FullPurchaseFragmentDoc}`;

/**
 * __useGetPurchaseQuery__
 *
 * To run a query within a React component, call `useGetPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseQuery({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *   },
 * });
 */
export function useGetPurchaseQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseQuery, GetPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseQuery, GetPurchaseQueryVariables>(GetPurchaseDocument, options);
      }
export function useGetPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseQuery, GetPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseQuery, GetPurchaseQueryVariables>(GetPurchaseDocument, options);
        }
export type GetPurchaseQueryHookResult = ReturnType<typeof useGetPurchaseQuery>;
export type GetPurchaseLazyQueryHookResult = ReturnType<typeof useGetPurchaseLazyQuery>;
export type GetPurchaseQueryResult = Apollo.QueryResult<GetPurchaseQuery, GetPurchaseQueryVariables>;
export const GetPurchasesDocument = gql`
    query GetPurchases {
  purchases {
    ...FullPurchase
  }
}
    ${FullPurchaseFragmentDoc}`;

/**
 * __useGetPurchasesQuery__
 *
 * To run a query within a React component, call `useGetPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchasesQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchasesQuery, GetPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasesQuery, GetPurchasesQueryVariables>(GetPurchasesDocument, options);
      }
export function useGetPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasesQuery, GetPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasesQuery, GetPurchasesQueryVariables>(GetPurchasesDocument, options);
        }
export type GetPurchasesQueryHookResult = ReturnType<typeof useGetPurchasesQuery>;
export type GetPurchasesLazyQueryHookResult = ReturnType<typeof useGetPurchasesLazyQuery>;
export type GetPurchasesQueryResult = Apollo.QueryResult<GetPurchasesQuery, GetPurchasesQueryVariables>;
export const GetSaleDocument = gql`
    query GetSale($collectionKey: String!) {
  sale(collectionKey: $collectionKey) {
    ...FullSale
  }
}
    ${FullSaleFragmentDoc}`;

/**
 * __useGetSaleQuery__
 *
 * To run a query within a React component, call `useGetSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleQuery({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *   },
 * });
 */
export function useGetSaleQuery(baseOptions: Apollo.QueryHookOptions<GetSaleQuery, GetSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleQuery, GetSaleQueryVariables>(GetSaleDocument, options);
      }
export function useGetSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleQuery, GetSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleQuery, GetSaleQueryVariables>(GetSaleDocument, options);
        }
export type GetSaleQueryHookResult = ReturnType<typeof useGetSaleQuery>;
export type GetSaleLazyQueryHookResult = ReturnType<typeof useGetSaleLazyQuery>;
export type GetSaleQueryResult = Apollo.QueryResult<GetSaleQuery, GetSaleQueryVariables>;
export const GetSalesDocument = gql`
    query GetSales {
  sales {
    ...FullSale
  }
}
    ${FullSaleFragmentDoc}`;

/**
 * __useGetSalesQuery__
 *
 * To run a query within a React component, call `useGetSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
      }
export function useGetSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
        }
export type GetSalesQueryHookResult = ReturnType<typeof useGetSalesQuery>;
export type GetSalesLazyQueryHookResult = ReturnType<typeof useGetSalesLazyQuery>;
export type GetSalesQueryResult = Apollo.QueryResult<GetSalesQuery, GetSalesQueryVariables>;
export const SubmitUserIdentityChecksDocument = gql`
    mutation SubmitUserIdentityChecks {
  submitKycUserIdentityChecks
}
    `;
export type SubmitUserIdentityChecksMutationFn = Apollo.MutationFunction<SubmitUserIdentityChecksMutation, SubmitUserIdentityChecksMutationVariables>;

/**
 * __useSubmitUserIdentityChecksMutation__
 *
 * To run a mutation, you first call `useSubmitUserIdentityChecksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUserIdentityChecksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUserIdentityChecksMutation, { data, loading, error }] = useSubmitUserIdentityChecksMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitUserIdentityChecksMutation(baseOptions?: Apollo.MutationHookOptions<SubmitUserIdentityChecksMutation, SubmitUserIdentityChecksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitUserIdentityChecksMutation, SubmitUserIdentityChecksMutationVariables>(SubmitUserIdentityChecksDocument, options);
      }
export type SubmitUserIdentityChecksMutationHookResult = ReturnType<typeof useSubmitUserIdentityChecksMutation>;
export type SubmitUserIdentityChecksMutationResult = Apollo.MutationResult<SubmitUserIdentityChecksMutation>;
export type SubmitUserIdentityChecksMutationOptions = Apollo.BaseMutationOptions<SubmitUserIdentityChecksMutation, SubmitUserIdentityChecksMutationVariables>;
export const UpdateLegalInfoDocument = gql`
    mutation UpdateLegalInfo($legalInfo: UserLegalInfoInput!) {
  updateLegalInfo(legalInfo: $legalInfo)
}
    `;
export type UpdateLegalInfoMutationFn = Apollo.MutationFunction<UpdateLegalInfoMutation, UpdateLegalInfoMutationVariables>;

/**
 * __useUpdateLegalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateLegalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegalInfoMutation, { data, loading, error }] = useUpdateLegalInfoMutation({
 *   variables: {
 *      legalInfo: // value for 'legalInfo'
 *   },
 * });
 */
export function useUpdateLegalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegalInfoMutation, UpdateLegalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegalInfoMutation, UpdateLegalInfoMutationVariables>(UpdateLegalInfoDocument, options);
      }
export type UpdateLegalInfoMutationHookResult = ReturnType<typeof useUpdateLegalInfoMutation>;
export type UpdateLegalInfoMutationResult = Apollo.MutationResult<UpdateLegalInfoMutation>;
export type UpdateLegalInfoMutationOptions = Apollo.BaseMutationOptions<UpdateLegalInfoMutation, UpdateLegalInfoMutationVariables>;
export const NegotiateReservationAgreementDocument = gql`
    mutation NegotiateReservationAgreement($reservationAgreementId: String!, $data: NegotiateReservationAgreementInput!) {
  isSuccessul: negotiateReservationAgreement(
    reservationAgreementId: $reservationAgreementId
    data: $data
  )
}
    `;
export type NegotiateReservationAgreementMutationFn = Apollo.MutationFunction<NegotiateReservationAgreementMutation, NegotiateReservationAgreementMutationVariables>;

/**
 * __useNegotiateReservationAgreementMutation__
 *
 * To run a mutation, you first call `useNegotiateReservationAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNegotiateReservationAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [negotiateReservationAgreementMutation, { data, loading, error }] = useNegotiateReservationAgreementMutation({
 *   variables: {
 *      reservationAgreementId: // value for 'reservationAgreementId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNegotiateReservationAgreementMutation(baseOptions?: Apollo.MutationHookOptions<NegotiateReservationAgreementMutation, NegotiateReservationAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NegotiateReservationAgreementMutation, NegotiateReservationAgreementMutationVariables>(NegotiateReservationAgreementDocument, options);
      }
export type NegotiateReservationAgreementMutationHookResult = ReturnType<typeof useNegotiateReservationAgreementMutation>;
export type NegotiateReservationAgreementMutationResult = Apollo.MutationResult<NegotiateReservationAgreementMutation>;
export type NegotiateReservationAgreementMutationOptions = Apollo.BaseMutationOptions<NegotiateReservationAgreementMutation, NegotiateReservationAgreementMutationVariables>;
export const RecordLeaseholdReviewMistakeDocument = gql`
    mutation RecordLeaseholdReviewMistake($data: LeaseholdReviewReportMistakeInput!) {
  recordLeaseholdReviewMistake(data: $data)
}
    `;
export type RecordLeaseholdReviewMistakeMutationFn = Apollo.MutationFunction<RecordLeaseholdReviewMistakeMutation, RecordLeaseholdReviewMistakeMutationVariables>;

/**
 * __useRecordLeaseholdReviewMistakeMutation__
 *
 * To run a mutation, you first call `useRecordLeaseholdReviewMistakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordLeaseholdReviewMistakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordLeaseholdReviewMistakeMutation, { data, loading, error }] = useRecordLeaseholdReviewMistakeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRecordLeaseholdReviewMistakeMutation(baseOptions?: Apollo.MutationHookOptions<RecordLeaseholdReviewMistakeMutation, RecordLeaseholdReviewMistakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordLeaseholdReviewMistakeMutation, RecordLeaseholdReviewMistakeMutationVariables>(RecordLeaseholdReviewMistakeDocument, options);
      }
export type RecordLeaseholdReviewMistakeMutationHookResult = ReturnType<typeof useRecordLeaseholdReviewMistakeMutation>;
export type RecordLeaseholdReviewMistakeMutationResult = Apollo.MutationResult<RecordLeaseholdReviewMistakeMutation>;
export type RecordLeaseholdReviewMistakeMutationOptions = Apollo.BaseMutationOptions<RecordLeaseholdReviewMistakeMutation, RecordLeaseholdReviewMistakeMutationVariables>;
export const RemovePurchaseFundingDocument = gql`
    mutation RemovePurchaseFunding($collectionKey: String!, $fundingId: Float!) {
  removePurchaseFunding(collectionKey: $collectionKey, fundingId: $fundingId) {
    collectionKey
    otherFunding {
      id
      source
      totalValue
    }
  }
}
    `;
export type RemovePurchaseFundingMutationFn = Apollo.MutationFunction<RemovePurchaseFundingMutation, RemovePurchaseFundingMutationVariables>;

/**
 * __useRemovePurchaseFundingMutation__
 *
 * To run a mutation, you first call `useRemovePurchaseFundingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePurchaseFundingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePurchaseFundingMutation, { data, loading, error }] = useRemovePurchaseFundingMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      fundingId: // value for 'fundingId'
 *   },
 * });
 */
export function useRemovePurchaseFundingMutation(baseOptions?: Apollo.MutationHookOptions<RemovePurchaseFundingMutation, RemovePurchaseFundingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePurchaseFundingMutation, RemovePurchaseFundingMutationVariables>(RemovePurchaseFundingDocument, options);
      }
export type RemovePurchaseFundingMutationHookResult = ReturnType<typeof useRemovePurchaseFundingMutation>;
export type RemovePurchaseFundingMutationResult = Apollo.MutationResult<RemovePurchaseFundingMutation>;
export type RemovePurchaseFundingMutationOptions = Apollo.BaseMutationOptions<RemovePurchaseFundingMutation, RemovePurchaseFundingMutationVariables>;
export const RemovePurchasePropertySaleDocument = gql`
    mutation RemovePurchasePropertySale($collectionKey: String!, $propertySaleId: Float!) {
  removePurchasePropertySale(
    collectionKey: $collectionKey
    propertySaleId: $propertySaleId
  ) {
    collectionKey
    propertySales {
      id
    }
  }
}
    `;
export type RemovePurchasePropertySaleMutationFn = Apollo.MutationFunction<RemovePurchasePropertySaleMutation, RemovePurchasePropertySaleMutationVariables>;

/**
 * __useRemovePurchasePropertySaleMutation__
 *
 * To run a mutation, you first call `useRemovePurchasePropertySaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePurchasePropertySaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePurchasePropertySaleMutation, { data, loading, error }] = useRemovePurchasePropertySaleMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      propertySaleId: // value for 'propertySaleId'
 *   },
 * });
 */
export function useRemovePurchasePropertySaleMutation(baseOptions?: Apollo.MutationHookOptions<RemovePurchasePropertySaleMutation, RemovePurchasePropertySaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePurchasePropertySaleMutation, RemovePurchasePropertySaleMutationVariables>(RemovePurchasePropertySaleDocument, options);
      }
export type RemovePurchasePropertySaleMutationHookResult = ReturnType<typeof useRemovePurchasePropertySaleMutation>;
export type RemovePurchasePropertySaleMutationResult = Apollo.MutationResult<RemovePurchasePropertySaleMutation>;
export type RemovePurchasePropertySaleMutationOptions = Apollo.BaseMutationOptions<RemovePurchasePropertySaleMutation, RemovePurchasePropertySaleMutationVariables>;
export const RequestSignInDocument = gql`
    mutation RequestSignIn($email: Email!) {
  requestSignIn(email: $email)
}
    `;
export type RequestSignInMutationFn = Apollo.MutationFunction<RequestSignInMutation, RequestSignInMutationVariables>;

/**
 * __useRequestSignInMutation__
 *
 * To run a mutation, you first call `useRequestSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSignInMutation, { data, loading, error }] = useRequestSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestSignInMutation(baseOptions?: Apollo.MutationHookOptions<RequestSignInMutation, RequestSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSignInMutation, RequestSignInMutationVariables>(RequestSignInDocument, options);
      }
export type RequestSignInMutationHookResult = ReturnType<typeof useRequestSignInMutation>;
export type RequestSignInMutationResult = Apollo.MutationResult<RequestSignInMutation>;
export type RequestSignInMutationOptions = Apollo.BaseMutationOptions<RequestSignInMutation, RequestSignInMutationVariables>;
export const RequestSignUpDocument = gql`
    mutation RequestSignUp($userDetails: CreateAccountInput!) {
  requestSignUp(userDetails: $userDetails)
}
    `;
export type RequestSignUpMutationFn = Apollo.MutationFunction<RequestSignUpMutation, RequestSignUpMutationVariables>;

/**
 * __useRequestSignUpMutation__
 *
 * To run a mutation, you first call `useRequestSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSignUpMutation, { data, loading, error }] = useRequestSignUpMutation({
 *   variables: {
 *      userDetails: // value for 'userDetails'
 *   },
 * });
 */
export function useRequestSignUpMutation(baseOptions?: Apollo.MutationHookOptions<RequestSignUpMutation, RequestSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSignUpMutation, RequestSignUpMutationVariables>(RequestSignUpDocument, options);
      }
export type RequestSignUpMutationHookResult = ReturnType<typeof useRequestSignUpMutation>;
export type RequestSignUpMutationResult = Apollo.MutationResult<RequestSignUpMutation>;
export type RequestSignUpMutationOptions = Apollo.BaseMutationOptions<RequestSignUpMutation, RequestSignUpMutationVariables>;
export const RequestUpgradeAccountDocument = gql`
    mutation RequestUpgradeAccount($userDetails: UpgradeAccountInput!) {
  upgradeToFullAccount(userDetails: $userDetails) {
    id
    preferredName
  }
}
    `;
export type RequestUpgradeAccountMutationFn = Apollo.MutationFunction<RequestUpgradeAccountMutation, RequestUpgradeAccountMutationVariables>;

/**
 * __useRequestUpgradeAccountMutation__
 *
 * To run a mutation, you first call `useRequestUpgradeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUpgradeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUpgradeAccountMutation, { data, loading, error }] = useRequestUpgradeAccountMutation({
 *   variables: {
 *      userDetails: // value for 'userDetails'
 *   },
 * });
 */
export function useRequestUpgradeAccountMutation(baseOptions?: Apollo.MutationHookOptions<RequestUpgradeAccountMutation, RequestUpgradeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUpgradeAccountMutation, RequestUpgradeAccountMutationVariables>(RequestUpgradeAccountDocument, options);
      }
export type RequestUpgradeAccountMutationHookResult = ReturnType<typeof useRequestUpgradeAccountMutation>;
export type RequestUpgradeAccountMutationResult = Apollo.MutationResult<RequestUpgradeAccountMutation>;
export type RequestUpgradeAccountMutationOptions = Apollo.BaseMutationOptions<RequestUpgradeAccountMutation, RequestUpgradeAccountMutationVariables>;
export const SubmitClaimDocument = gql`
    mutation SubmitClaim($reservationAgreementId: String!, $claim: ClaimInput!) {
  isSubmitted: submitClaim(
    reservationAgreementId: $reservationAgreementId
    claim: $claim
  )
}
    `;
export type SubmitClaimMutationFn = Apollo.MutationFunction<SubmitClaimMutation, SubmitClaimMutationVariables>;

/**
 * __useSubmitClaimMutation__
 *
 * To run a mutation, you first call `useSubmitClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitClaimMutation, { data, loading, error }] = useSubmitClaimMutation({
 *   variables: {
 *      reservationAgreementId: // value for 'reservationAgreementId'
 *      claim: // value for 'claim'
 *   },
 * });
 */
export function useSubmitClaimMutation(baseOptions?: Apollo.MutationHookOptions<SubmitClaimMutation, SubmitClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitClaimMutation, SubmitClaimMutationVariables>(SubmitClaimDocument, options);
      }
export type SubmitClaimMutationHookResult = ReturnType<typeof useSubmitClaimMutation>;
export type SubmitClaimMutationResult = Apollo.MutationResult<SubmitClaimMutation>;
export type SubmitClaimMutationOptions = Apollo.BaseMutationOptions<SubmitClaimMutation, SubmitClaimMutationVariables>;
export const SubmitOfferDocument = gql`
    mutation SubmitOffer($offer: CreateOfferInput!) {
  createOffer(offer: $offer) {
    id
  }
}
    `;
export type SubmitOfferMutationFn = Apollo.MutationFunction<SubmitOfferMutation, SubmitOfferMutationVariables>;

/**
 * __useSubmitOfferMutation__
 *
 * To run a mutation, you first call `useSubmitOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOfferMutation, { data, loading, error }] = useSubmitOfferMutation({
 *   variables: {
 *      offer: // value for 'offer'
 *   },
 * });
 */
export function useSubmitOfferMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOfferMutation, SubmitOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOfferMutation, SubmitOfferMutationVariables>(SubmitOfferDocument, options);
      }
export type SubmitOfferMutationHookResult = ReturnType<typeof useSubmitOfferMutation>;
export type SubmitOfferMutationResult = Apollo.MutationResult<SubmitOfferMutation>;
export type SubmitOfferMutationOptions = Apollo.BaseMutationOptions<SubmitOfferMutation, SubmitOfferMutationVariables>;
export const BookSurveyDocument = gql`
    mutation BookSurvey($data: SurveyInput!) {
  bookSurvey(data: $data) {
    id
    type
    status
  }
}
    `;
export type BookSurveyMutationFn = Apollo.MutationFunction<BookSurveyMutation, BookSurveyMutationVariables>;

/**
 * __useBookSurveyMutation__
 *
 * To run a mutation, you first call `useBookSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookSurveyMutation, { data, loading, error }] = useBookSurveyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBookSurveyMutation(baseOptions?: Apollo.MutationHookOptions<BookSurveyMutation, BookSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookSurveyMutation, BookSurveyMutationVariables>(BookSurveyDocument, options);
      }
export type BookSurveyMutationHookResult = ReturnType<typeof useBookSurveyMutation>;
export type BookSurveyMutationResult = Apollo.MutationResult<BookSurveyMutation>;
export type BookSurveyMutationOptions = Apollo.BaseMutationOptions<BookSurveyMutation, BookSurveyMutationVariables>;
export const UpdateMortgageAdjustmentDocument = gql`
    mutation UpdateMortgageAdjustment($collectionKey: String!, $data: UpdateMortgageAdjustmentInput!) {
  updateMortgageAdjustment(
    collectionKey: $collectionKey
    mortgageAdjustment: $data
  ) {
    collectionKey
    mortgageAdjustment {
      fromValue
      toValue
    }
  }
}
    `;
export type UpdateMortgageAdjustmentMutationFn = Apollo.MutationFunction<UpdateMortgageAdjustmentMutation, UpdateMortgageAdjustmentMutationVariables>;

/**
 * __useUpdateMortgageAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageAdjustmentMutation, { data, loading, error }] = useUpdateMortgageAdjustmentMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMortgageAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageAdjustmentMutation, UpdateMortgageAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageAdjustmentMutation, UpdateMortgageAdjustmentMutationVariables>(UpdateMortgageAdjustmentDocument, options);
      }
export type UpdateMortgageAdjustmentMutationHookResult = ReturnType<typeof useUpdateMortgageAdjustmentMutation>;
export type UpdateMortgageAdjustmentMutationResult = Apollo.MutationResult<UpdateMortgageAdjustmentMutation>;
export type UpdateMortgageAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageAdjustmentMutation, UpdateMortgageAdjustmentMutationVariables>;
export const UpdatePurchaseDocument = gql`
    mutation UpdatePurchase($collectionKey: String!, $updatedPurchase: UpdatePurchaseInput!) {
  updatePurchase(collectionKey: $collectionKey, purchase: $updatedPurchase) {
    collectionKey
    name
    purchasePrice
    purchaseCountry
    tenure
    cashAmount
    isFirstPropertyPurchase
  }
}
    `;
export type UpdatePurchaseMutationFn = Apollo.MutationFunction<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>;

/**
 * __useUpdatePurchaseMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseMutation, { data, loading, error }] = useUpdatePurchaseMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      updatedPurchase: // value for 'updatedPurchase'
 *   },
 * });
 */
export function useUpdatePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>(UpdatePurchaseDocument, options);
      }
export type UpdatePurchaseMutationHookResult = ReturnType<typeof useUpdatePurchaseMutation>;
export type UpdatePurchaseMutationResult = Apollo.MutationResult<UpdatePurchaseMutation>;
export type UpdatePurchaseMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseMutation, UpdatePurchaseMutationVariables>;
export const UpdatePurchaseFundingDocument = gql`
    mutation UpdatePurchaseFunding($collectionKey: String!, $fundingId: Float!, $funding: UpdateFundingInput!) {
  updatePurchaseFunding(
    collectionKey: $collectionKey
    fundingId: $fundingId
    funding: $funding
  ) {
    collectionKey
    otherFunding {
      id
      source
      totalValue
    }
  }
}
    `;
export type UpdatePurchaseFundingMutationFn = Apollo.MutationFunction<UpdatePurchaseFundingMutation, UpdatePurchaseFundingMutationVariables>;

/**
 * __useUpdatePurchaseFundingMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseFundingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseFundingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseFundingMutation, { data, loading, error }] = useUpdatePurchaseFundingMutation({
 *   variables: {
 *      collectionKey: // value for 'collectionKey'
 *      fundingId: // value for 'fundingId'
 *      funding: // value for 'funding'
 *   },
 * });
 */
export function useUpdatePurchaseFundingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseFundingMutation, UpdatePurchaseFundingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseFundingMutation, UpdatePurchaseFundingMutationVariables>(UpdatePurchaseFundingDocument, options);
      }
export type UpdatePurchaseFundingMutationHookResult = ReturnType<typeof useUpdatePurchaseFundingMutation>;
export type UpdatePurchaseFundingMutationResult = Apollo.MutationResult<UpdatePurchaseFundingMutation>;
export type UpdatePurchaseFundingMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseFundingMutation, UpdatePurchaseFundingMutationVariables>;
export const UploadLeaseholdReviewDocument = gql`
    mutation UploadLeaseholdReview($data: LeaseholdReviewInput!) {
  leasholdReview(data: $data) {
    id
  }
}
    `;
export type UploadLeaseholdReviewMutationFn = Apollo.MutationFunction<UploadLeaseholdReviewMutation, UploadLeaseholdReviewMutationVariables>;

/**
 * __useUploadLeaseholdReviewMutation__
 *
 * To run a mutation, you first call `useUploadLeaseholdReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLeaseholdReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLeaseholdReviewMutation, { data, loading, error }] = useUploadLeaseholdReviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadLeaseholdReviewMutation(baseOptions?: Apollo.MutationHookOptions<UploadLeaseholdReviewMutation, UploadLeaseholdReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadLeaseholdReviewMutation, UploadLeaseholdReviewMutationVariables>(UploadLeaseholdReviewDocument, options);
      }
export type UploadLeaseholdReviewMutationHookResult = ReturnType<typeof useUploadLeaseholdReviewMutation>;
export type UploadLeaseholdReviewMutationResult = Apollo.MutationResult<UploadLeaseholdReviewMutation>;
export type UploadLeaseholdReviewMutationOptions = Apollo.BaseMutationOptions<UploadLeaseholdReviewMutation, UploadLeaseholdReviewMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($verifyEmail: VerifyEmailInput!) {
  requestVerifyEmailLink(verifyEmail: $verifyEmail)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      verifyEmail: // value for 'verifyEmail'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BusinessUnion": [
      "ConveyancingBusiness"
    ],
    "ItemUnion": [
      "ConveyancingRecommendations",
      "PersonalProtectPolicies",
      "ProtectInvitations"
    ]
  }
};
      export default result;
    